(function() {
  'use strict';

  angular
    .module('mad', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ngMaterial', 'toastr', 'ngFileUpload', 'angularQFileUpload']);

})();

/**
 * Created by JiXiang on 2016/3/28.
 */
(function() {
  'use strict';

  angular
    .module('mad')
    .directive('acmeNavbarAd', acmeNavbarAd);

  /** @ngInject */
  function acmeNavbarAd() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar-advert/navbar-advert.html',
      scope: {
        creationDate: '='
      },
      controller: NavbarAdController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarAdController($scope, $location) {
      $scope.isManage = false;
      $scope.isPush = false;
      $scope.isList = false;

      $scope.isPay = false;
      $scope.isPut = false;
      $scope.isBack = false;

      $scope.isStatistics = false;
      $scope.isAccount = false;
      $scope.isAdSta = false;

      var path = $location.path();
      console.log('path:' + path);
      if (path == '/advert/push') {
        $scope.isManage = true;
        $scope.isPush = true;
      }

      if (path == '/advert') {
        $scope.isManage = true;
        $scope.isList = true;
      }

      if (path == '/account/reacharge') {
        $scope.isPay = true;
        $scope.isPut = true;
      }

      if (path == '/account/refund') {
        $scope.isPay = true;
        $scope.isBack = true;
      }

      if (path == '/account/check') {
        $scope.isStatistics = true;
        $scope.isAccount = true;
      }
      if (path == '/statistics') {
        $scope.isStatistics = true;
        $scope.isAdSta = true;
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('mad')
    .controller('HeaderCtrl', HeaderCtrl);

  /** @ngInject */
  function HeaderCtrl($rootScope, $scope, $location, $state, AdvertiserSrv, TokenSrv, NoticeSrv) {
    $scope.isMain = false;

    $scope.isManage = false;
    $scope.isPush = false;
    $scope.isList = false;

    $scope.isPay = false;
    $scope.isPut = false;
    $scope.isBack = false;
    $scope.isConfirm = false;

    $scope.isStatistics = false;
    $scope.isAccSta = false;
    $scope.isAdSta = false;

    $scope.isMsg = false;

    $scope.isAccount = false;

    if ($location.path() == '/advert/push') {
      $scope.isManage = true;
      $scope.isPush = true;
    }

    if ($location.path() == '/advert') {
      $scope.isManage = true;
      $scope.isList = true;
    }

    if ($location.path() == '/account/recharge') {
      $scope.isPay = true;
      $scope.isPut = true;
    }

    if ($location.path() == '/account/refund') {
      $scope.isPay = true;
      $scope.isBack = true;
    }

    if ($location.path() == '/account/check') {
      $scope.isPay = true;
      $scope.isConfirm = true;
    }

    if ($location.path() == '/statistics') {
      $scope.isStatistics = true;
      $scope.isAccSta = true;
    }

    if ($location.path() == '/statistics/detail') {
      $scope.isStatistics = true;
      $scope.isAdSta = true;
    }

    if ($location.path() == '/account') {
      $scope.isAccount = true;
    }

    if ($location.path() == '/notification') {
      $scope.isMsg = true;
    }

    $('#signup').on('hide.bs.modal', function (e) {
      $scope.thereIsError = false;
      $scope.errMessage = '';
      console.log('hide signup');

    });

    $('#login').on('hide.bs.modal', function (e) {
      $scope.thereIsError = false;
      $scope.errMessage = '';
      console.log('hide login');
    })

    // console.log('token:' + TokenSrv.getToken());
    if (TokenSrv.getToken()) {
      $rootScope.logined = true;
      $scope.name = TokenSrv.getName();
    } else {
      $rootScope.logined = false;
    }
    $scope.isLogin = $rootScope.logined;
    $scope.thereIsError = false;

    // 注册
    $scope.register = function (nickname, email, pass, confirmPass) {
      if (!nickname || !email || !pass || !confirmPass) {
        $scope.thereIsError = true;
        $scope.errMessage = '请输入完整信息';
        return;
      }
      if (pass.length < 8) {
        $scope.thereIsError = true;
        $scope.errMessage = '密码至少要8位';
        return;
      }
      if (pass !== confirmPass) {
        $scope.thereIsError = true;
        $scope.errMessage = '两次输入密码不一致';
        return;
      }
      if (email.search(/^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/) === -1) {
        $scope.thereIsError = true;
        $scope.errMessage = '请输入合法邮箱';
        return;
      }


      $scope.thereIsError = false;
      var sha256Pass = sha256(pass);

      AdvertiserSrv.register().save({
          username: nickname,
          email: email,
          password: sha256Pass
        }).$promise.then(
          function (response) {
            console.log(response);
            if (0 === response.errCode) {
              console.log('注册成功');
              NoticeSrv.success('恭喜您注册成功，请您验证邮箱后登录');
              $('#signup').modal('hide');
            }
          }, function (error) {
            console.log('注册失败');
            console.log(error);
            $scope.thereIsError = true;
            $scope.errMessage = '未知错误' + error;
          });

    };

    // 登录
    $scope.login = function (email, pass) {
      $scope.thereIsError = false;

      if (!email || !pass) {
        $scope.thereIsError = true;
        $scope.errMessage = '请输入用户名和密码';
        return;
      }
      if (email.search(/^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/) === -1) {
        $scope.thereIsError = true;
        $scope.errMessage = '请输入合法邮箱';
        return;
      }

      var sha256Pass = sha256(pass);
      // console.log('sha256:' + sha256Pass);

      AdvertiserSrv.login().save({
        email: email,
        password: sha256Pass
      }).$promise.then(
        function (response) {
          console.log(response.errCode);
          if (0 === response.errCode) {
            console.log('登录成功');
            TokenSrv.setToken(response.token);
            TokenSrv.setName(response.name);
            $('#login').modal('hide');
            $scope.isLogin = true;
            $scope.name = response.name;
            $rootScope.logined = true;
          }
        }, function(error) {
          console.log('登录失败');
          console.log(error);
        });
    };

    $scope.logout = function () {
      TokenSrv.setToken('');
      $scope.isLogin = false;
      $rootScope.logined = false;
      $state.go('app', {reload: true});
    };
  }
})();

/**
 * Created by mandyxue on 16/3/31.
 */
(function() {
  'use strict';

  angular
    .module('mad')
    .controller('FooterCtrl', FooterCtrl);

  /** @ngInject */
  function FooterCtrl() {

  }
})();

/**
 * Created by LENOVO on 2016/3/29.
 */
(function () {
  'use strict';
  angular
    .module('mad')
    .controller('SatisticsDetailCtrl', SatisticsDetailCtrl);

      /** @ngInject */
  function SatisticsDetailCtrl($scope, $stateParams, StatisticsSrv) {

    $scope.advertId = $stateParams.advertId;
    StatisticsSrv.getAdvertDetail().get({
        id: $scope.advertId
      }).$promise.then(function (response) {
          if (0 === response.errCode) {
            console.log('statistics data:');
            console.log(response.statistics);

            // parse date
            response.statistics.forEach(function (data) {
              data.date = moment(data.date).toDate();
            });
            var chartData = response.statistics;

            var chart = AmCharts.makeChart("chartdiv", {
              "type": "serial",
              "theme": "light",
              "marginRight": 80,
              "dataProvider": response.statistics,
              "valueAxes": [{
                "position": "left",
                "title": "广告投放"
              }],
              "graphs": [{
                "id": "g1",
                "fillAlphas": 0.4,
                "valueField": "totalBroadcast",
                "balloonText": "<div style='margin:5px; font-size:19px;'>投放:<b>[[value]]</b></div>"
              }],
              "chartScrollbar": {
                "graph": "g1",
                "scrollbarHeight": 80,
                "backgroundAlpha": 0,
                "selectedBackgroundAlpha": 0.1,
                "selectedBackgroundColor": "#888888",
                "graphFillAlpha": 0,
                "graphLineAlpha": 0.5,
                "selectedGraphFillAlpha": 0,
                "selectedGraphLineAlpha": 1,
                "autoGridCount": true,
                "color": "#AAAAAA"
              },
              "chartCursor": {
                "categoryBalloonDateFormat": "DD MMMM",
                "cursorPosition": "mouse"
              },
              "categoryField": "date",
              "categoryAxis": {
                "minPeriod": "mm",
                "parseDates": true
              },
              "export": {
                "enabled": true
              }
            });
          }
      }, function (error) {
          console.log(error);
      });
  }
})();

/**
 * Created by Teng on 2016/4/10.
 */
(function () {
  'use strict';
  angular
    .module('mad')
    .controller('SatisticsAdvertMapCtrl', SatisticsAdvertMapCtrl);

  function SatisticsAdvertMapCtrl($scope, StatisticsSrv) {

    function dateExist(array, date) {
      var i;
      for (i = 0; i < array.length; i += 1) {
        if (array[i].date.getTime() === date.getTime()) {
          return i;
        }
      }
    }

    function generateChartData(rawData) {
      var chartData = [];
      var index, advertData, element;
      var i = 0, j = 0;

      for (i = 0; i < 3; i += 1) {
        advertData = rawData[i].data;

        for (j = 0; j < advertData.length; j += 1) {

          index = dateExist(chartData, advertData[j].date);
          if (index === undefined) {
            element = {
              'date': advertData[j].date,
              'advert1': 0,
              'advert2': 0,
              'advert3': 0
            };
            if (i === 0) {
              element.advert1 = advertData[j].num;
            } else if (i === 1) {
              element.advert2 = advertData[j].num;
            } else if (i === 2) {
              element.advert3 = advertData[j].num;
            }
            chartData.push(element);
          } else {
            if (i === 0) {
              chartData[index].advert1 = advertData[j].num;
            } else if (i === 1) {
              chartData[index].advert2 = advertData[j].num;
            } else if (i === 2) {
              chartData[index].advert3 = advertData[j].num;
            }
          }
        }
      }
      chartData.sort(function (a, b) {
        return a.date.getTime() - b.date.getTime();
      });

      return chartData;
    }


    StatisticsSrv.getStatisticsData().get().$promise
      .then(function (response) {
          if (0 === response.errCode) {
            // 该广告商所有广告投放数据
            // console.log('response');
            // console.log(response.advertisement);

            var broadcastData = [];
            var costData = [];
            var i = 0;
            var j = 0;

            var element;
            for (i = 0; i < response.advertisement.length; i += 1) {
              element = response.advertisement[i];
              broadcastData[i] = {
                'id': element.id,
                'data': [],
                'sum': 0
              };

              costData[i] = {
                'id': element.id,
                'data': [],
                'sum': 0
              }

              for (j = 0; j < element.statistics.length; j += 1) {
                broadcastData[i].sum += element.statistics[j].totalBroadcast;
                broadcastData[i].data.push({
                  'date': moment(element.statistics[j].date).toDate(),
                  'num': element.statistics[j].totalBroadcast
                });

                costData[i].sum += element.statistics[j].totalPrice;
                costData[i].data.push({
                  'date': moment(element.statistics[j].date).toDate(),
                  'num': element.statistics[j].totalPrice
                });
              }
            }
            broadcastData.sort(function (a, b) {
              return b.sum - a.sum;
            });
            costData.sort(function (a, b) {
              return b.sum - a.sum;
            });
            // console.log(broadcastData);
            // console.log(costData);

            // 取投放量最高的前三名
            var chart1Data = [];
            var chart2Data = [];
            var advertData;
            var index;
            if (broadcastData.length > 2) {
              var chart1Data = generateChartData(broadcastData);

              console.log('chart1Data');
              console.log(chart1Data);

              var chart = AmCharts.makeChart("chartdiv", {
                  "type": "serial",
                  "theme": "light",
                  "marginRight": 40,
                  "marginLeft": 40,
                  "autoMarginOffset": 20,
                  "mouseWheelZoomEnabled":true,
                  "dataDateFormat": "YYYY-MM-DD",
                  "valueAxes": [{
                      "id": "v1",
                      "axisAlpha": 0,
                      "position": "left",
                      "ignoreAxisWidth":true
                  }],
                  "balloon": {
                      "borderThickness": 1,
                      "shadowAlpha": 0
                  },
                  "graphs": [{
                          "id": "g1",
                          "balloon":{
                          "drop":true,
                          "adjustBorderColor":false,
                          "color":"#ffffff"
                      },
                      "bullet": "round",
                      "bulletBorderAlpha": 1,
                      "bulletColor": "#FFFFFF",
                      "bulletSize": 5,
                      "hideBulletsCount": 50,
                      "lineThickness": 2,
                      "title": broadcastData[0].id,
                      "useLineColorForBulletBorder": true,
                      "valueField": "advert1",
                      "balloonText": "<span style='font-size:18px;'>[[value]]</span>"
                  },
                  {
                      "id": "g2",
                      "balloon":{
                      "drop":true,
                      "adjustBorderColor":false,
                      "color":"#ffffff"
                      },
                      "bullet": "round",
                      "bulletBorderAlpha": 1,
                      "bulletColor": "#FFFFFF",
                      "bulletSize": 5,
                      "hideBulletsCount": 50,
                      "lineThickness": 2,
                      "title": "advertisment2",
                      "useLineColorForBulletBorder": true,
                      "valueField": "advert2",
                      "balloonText": "<span style='font-size:18px;'>[[value]]</span>"
                  },
                  {
                      "id": "g3",
                      "balloon":{
                      "drop":true,
                      "adjustBorderColor":false,
                      "color":"#ffffff"
                      },
                      "bullet": "round",
                      "bulletBorderAlpha": 1,
                      "bulletColor": "#FFFFFF",
                      "bulletSize": 5,
                      "hideBulletsCount": 50,
                      "lineThickness": 2,
                      "title": "advertisment3",
                      "useLineColorForBulletBorder": true,
                      "valueField": "advert3",
                      "balloonText": "<span style='font-size:18px;'>[[value]]</span>"
                  }],
                  "chartScrollbar": {
                      "graph": "g1",
                      "oppositeAxis":false,
                      "offset":30,
                      "scrollbarHeight": 80,
                      "backgroundAlpha": 0,
                      "selectedBackgroundAlpha": 0.1,
                      "selectedBackgroundColor": "#888888",
                      "graphFillAlpha": 0,
                      "graphLineAlpha": 0.5,
                      "selectedGraphFillAlpha": 0,
                      "selectedGraphLineAlpha": 1,
                      "autoGridCount":true,
                      "color":"#AAAAAA"
                  },
                  "chartCursor": {
                      "pan": true,
                      "valueLineEnabled": true,
                      "valueLineBalloonEnabled": true,
                      "cursorAlpha":1,
                      "cursorColor":"#258cbb",
                      "limitToGraph":"g1",
                      "valueLineAlpha":0.2
                  },
                  "valueScrollbar":{
                  "oppositeAxis":false,
                  "offset":50,
                  "scrollbarHeight":10
                  },
                  "categoryField": "date",
                  "categoryAxis": {
                      "parseDates": true,
                      "dashLength": 1,
                      "minorGridEnabled": true
                  },
                  "export": {
                      "enabled": true
                  },
                  "dataProvider": chart1Data
              });
            } else {
              // 有几个取几个
            }

            if (costData.length > 2) {
              var chart2Data = generateChartData(costData);

              var chart = AmCharts.makeChart("advertisment-chart", {
                  "type": "serial",
                  "theme": "light",
                  "legend": {
                      "useGraphSettings": true
                  },
                  "dataProvider": chart2Data,
                  "valueAxes": [{
                      "id":"v1",
                      "axisColor": "#FF6600",
                      "axisThickness": 2,
                      "gridAlpha": 0,
                      "axisAlpha": 1,
                      "position": "left"
                  }, {
                      "id":"v2",
                      "axisColor": "#FCD202",
                      "axisThickness": 2,
                      "gridAlpha": 0,
                      "axisAlpha": 1,
                      "position": "right"
                  }, {
                      "id":"v3",
                      "axisColor": "#B0DE09",
                      "axisThickness": 2,
                      "gridAlpha": 0,
                      "offset": 50,
                      "axisAlpha": 1,
                      "position": "left"
                  }],
                  "graphs": [{
                      "valueAxis": "v1",
                      "lineColor": "#FF6600",
                      "bullet": "round",
                      "bulletBorderThickness": 1,
                      "hideBulletsCount": 30,
                      "title": costData[0].id,
                      "valueField": "advert1",
                      "fillAlphas": 0
                  }, {
                      "valueAxis": "v2",
                      "lineColor": "#FCD202",
                      "bullet": "square",
                      "bulletBorderThickness": 1,
                      "hideBulletsCount": 30,
                      "title": costData[1].id,
                      "valueField": "advert2",
                      "fillAlphas": 0
                  }, {
                      "valueAxis": "v3",
                      "lineColor": "#B0DE09",
                      "bullet": "triangleUp",
                      "bulletBorderThickness": 1,
                      "hideBulletsCount": 30,
                      "title": costData[2].id,
                      "valueField": "advert3",
                      "fillAlphas": 0
                  }],
                  "chartScrollbar": {},
                  "chartCursor": {
                      "cursorPosition": "mouse"
                  },
                  "categoryField": "date",
                  "categoryAxis": {
                      "parseDates": true,
                      "axisColor": "#DADADA",
                      "minorGridEnabled": true
                  },
                  "export": {
                      "enabled": true,
                      "position": "bottom-right"
                  }
              });
            } else {
              // 有几个取几个
            }
          }
      }).catch(function (error) {
          console.log(error);
      });
  }
})();

(function() {
  'use strict';

  angular
    .module('mad')
    .factory('TokenSrv', TokenSrv);

  /** @ngInject */
  function TokenSrv($cookies) {
    return {
          token: '',// for test:6e777a9556c6774e6b62ff9a18ec456e3f05181260cf1a129811a4a08152fbaa
          name: '',
          setToken: function (token) {
              this.token = token;
              $cookies.put('token', token);
          },
          getToken: function () {
            if (!this.token) {
              this.token = $cookies.get('token');
            }
            return this.token;
          },
          setName: function(name) {
            this.name = name;
            $cookies.put('name', name);
          },
          getName: function() {
            if (!this.name) {
              this.name = $cookies.get('name');
            }
            return this.name;
          }
        };
  }
})();

(function() {
  'use strict';

  angular
    .module('mad')
    .service('StatisticsSrv', StatisticsSrv);

  /** @ngInject */
  function StatisticsSrv($resource, baseURL) {
    this.getAdvertisementStatistics = function () {
        return $resource(baseURL + '/statistics/all');
    };
    
    this.getAdvertDetail = function () {
        return $resource(baseURL + '/statistics/detail/:id', {
          id: 'id'
        });
    };
    
    this.getStatisticsData = function() {
        return $resource(baseURL + '/statistics/data');
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('mad')
    .factory('NoticeSrv', NoticeSrv);

  /** @ngInject */
  function NoticeSrv($compile, $timeout, $rootScope) {
    var notification = {};

  notification.timer = null;
  notification.__alert__ = function(css, title, text) {
    var template = ['<div class="notice fixed alert alert-dismissible ',
                      css,
                      '">',
                      '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>',
                      '<strong>',
                      title,
                      '</strong>',
                      text,
                      '</div>'].join('');
    if (angular.element(document).find('.notice')) {
      angular.element(document).find('.notice').remove();
    }
    if (this.timer) {
      $timeout.cancel(this.timer);
    }
    angular.element(document).find('body').append($compile(template)($rootScope));
    this.timer = $timeout(function() {
      angular.element(document).find('.notice').remove();
    }, 5000);
  };

  notification.success = function(text) {
    this.__alert__('alert-success', '成功: ', text);
  };

  notification.error = function(text) {
    this.__alert__('alert-danger', '错误: ', text);

  };

  notification.notice = function(text) {
    this.__alert__('alert-info', '提示: ', text);
  };

  return notification;
    
    
  }
})();

(function() {
  'use strict';

  angular
    .module('mad')
    .factory('myInterceptor', myInterceptor);

  /** @ngInject */
  function myInterceptor($rootScope, $injector, TokenSrv, baseURL) {
    //   console.log('helloworld');
    var myInterceptor = {
                request: function (config) {
                    // 通过配置拦截器在发送请求前注入token
                    if (arguments[0].url.indexOf(baseURL) !== -1) {
                        if (arguments[0].method === 'GET' || arguments[0].method === 'DELETE' || arguments[0].method === 'OPTIONS') {
                            arguments[0].params = arguments[0].params || {};
                            // console.log(arguments);
                            arguments[0].params.token = TokenSrv.getToken();
                        }
                        if (arguments[0].method === 'POST' || arguments[0].method === 'PUT') {
                            arguments[0].data = arguments[0].data || {};
                            arguments[0].data.token = TokenSrv.getToken();
                        }
                    }

                    // 必须用过injector注入$state,  不然会有BUG,
                    // 详见http://stackoverflow.com/questions/20230691/injecting-state-ui-router-into-http-interceptor-causes-circular-dependency
                    var $state = $injector.get('$state');
                    // 不在登陆页面且未登陆
                    // console.log($state.current.url);
                    if ( !$rootScope.logined && ($state.current.url !== '\\' && $state.current.url !== '^')) {
                        $injector.get('$state').go('app', {reload: true});
                    }
                    if (!TokenSrv.getToken()) {
                        window.location.replace('#/');
                    }
                    return config;
                },
                response: function (response) {
                  // response.data.errCode === 101
                  // response.errCode = 101
                    if (response.data.errCode === 101) {
                        console.log('errCode:' + response.data.errCode);
                        $injector.get('NoticeSrv').notice($injector.get('ErrorSrv').getError(response.data.errCode + ""));
                        TokenSrv.setToken('');

                        var $state = $injector.get('$state');
                        $injector.get('$state').go('app');
                    }
                    if (response.data.errCode && response.data.errCode !== 0) {
                        $injector.get('NoticeSrv').error($injector.get('ErrorSrv').getError(response.data.errCode + ""));
                        console.log('errCode:' + response.data.errCode);
                    }


                    return response;
                }
            };
            return myInterceptor;
  }
})();

(function() {
  'use strict';

  angular
    .module('mad')
    .factory('ErrorSrv', ErrorSrv);

  /** @ngInject */
  function ErrorSrv() {
    var error, getError;

    error = {
        '101': '令牌不存在或已经过期, 请重新登陆',
        '102':'用户名或密码错误',
        '103':'该用户邮箱未验证',
        '104':'该用户邮箱已被注册',
        '105':'该用户手机号已被注册',
        '106':'该用户手机号未验证',
        '107':'邮箱验证码过期或错误，验证失败，需要重新注册',
        '108':'参数不正确',
        '109':'',
        '111':'',
        '112':'',
        '113':'',
        '201':'广告不存在',
        '202':'广告类别错误',
        '203':'广告标题不能为空',
        '204':'投放地点错误',
        '205':'广告起始日期不能大于结束日期',
        '206':'广告状态错误',
        '207':'广告上传失败',
        '208':'广告下架失败',
        '209':'发布广告失败',
        '210':'保存草稿太频繁',
        '211':'',
        '301':'金额必须大于0',
        '302':'验证信息不完整',
        '303':'图片上传失败',
        '304':'退款金额大于余额',
        '305':'旧密码不对',
        '306':'行政区映射修改失败',
        '307':'',
        '308':'',
        '999':'未知错误'

    };

    getError = function(errCode) {
        return error[errCode];
    };

    return {
        getError: getError
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('mad')
    .service('AdvertiserSrv', AdvertiserSrv);

  /** @ngInject */
  function AdvertiserSrv($resource, baseURL) {

    this.applyState = {
      '01': '申请等待处理',
      '00': '申请被拒绝',
      '11': '申请通过'
    }


    this.register = function () {
        return $resource(baseURL + '/signup');
    };

    this.login = function () {
        return $resource(baseURL + '/login');
    };

    this.checkInfo = function () {
        return $resource(baseURL + '/account/check');
    };

    this.formatCheckInfo = function (data) {

      if (data.businessPeriodIsLong) {
        data.businessPeriod = '长期';
      } else {
        var day = moment(data.businessPeriod);
        data.businessPeriodStr = day.format('YYYY-MM-DD HH:mm:ss');

      }

      if (data.legalPersonIdIsLong) {
        data.legalPersonValidDateStr = '长期';
      } else {
        day = moment(data.legalPersonValidDate);
        data.legalPersonValidDateStr = day.format('YYYY-MM-DD HH:mm:ss');
      }

      return data;
    };

    this.parseCheckInfo = function (data) {
      // 单位所在地，营业期限
      // 省份证有效期
      // 填写人身份
      data.companyLocationProvince = data.location.split(',')[0];
      data.companyLocationDistrict = data.location.split(',')[1];
      var day;
      if (!data.legalPerson.iflongterm) {
        day = moment(data.businessPeriod);
        data.periodDate = day.toDate();
      }

      if (!data.periodIsLong) {
        day = moment(data.legalPerson.validDate);
        data.legalPerson.idValidDate = day.toDate();
      }

      return data;
    };

    this.parseDateFromStr = function (dateStr) {
      var momentDate = moment(dateStr);
      return momentDate.toDate();
    };

    this.formatDate = function (date) {
      var momentDate = moment(date);
      return momentDate.format('YYYY-MM-DD HH:mm:ss');
    }

    this.getAccountDetails = function () {
      return $resource(baseURL + '/account/detail');
    };

    this.getMessages = function () {
      return $resource(baseURL + '/message');
    };

    this.recharge = function () {
      return $resource(baseURL + '/account/recharge');
    };

    this.refund = function () {
      return $resource(baseURL + '/account/refund');
    };

    this.getRechargeHistory = function () {
      return $resource(baseURL + '/account/recharge/all');
    };

    this.getRefundHistory = function () {
      return $resource(baseURL + '/account/refund/all');
    };

    this.changePassword = function () {
      return $resource(baseURL + '/account/changePwd');
    };

    this.changeAlipay = function () {
      return $resource(baseURL + '/account/changeAlipay');
    };

    this.getCheckDetail = function () {
      return $resource(baseURL + '/account/check/detail');
    };

    this.getUpToken = function () {
      return $resource(baseURL + '/account/check/uptoken');
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('mad')
    .service('AdvertisementSrv', AdvertisementSrv);

  /** @ngInject */
  function AdvertisementSrv($resource, baseURL) {

    this.advertTypes = [{
      id: 'other',
      type: '其他'
    },{
      id: 'accommodation',
      type: '食宿'
    }, {
      id: 'commodity',
      type: '商品'
    }, {
      id: 'education',
      type: '教育'
    },{
      id: 'entertainment',
      type: '影视娱乐'
    },{
      id: 'recruit',
      type: '招聘'
    },{
      id: 'service',
      type: '服务'
    },{
      id: 'social',
      type: '社交'
    },{
      id: 'tenancy',
      type: '租赁'
    }];

    this.types = {
      'other': '其他',
      'accommodation': '食宿',
      'commodity': '商品',
      'education': '教育',
      'entertainment': '影视娱乐',
      'recruit': '招聘',
      'service': '服务',
      'social': '社交',
      'tenancy': '租赁'
    };



    this.advertCities = [{
      id: 'Shanghai',
      city: '上海'
    }];


    this.getReleaseAdvertisement = function () {
        return $resource(baseURL + '/advertisement/list/all');
    };

    this.saveDraftAdvertisement = function () {
        return $resource(baseURL + '/advertisement/save');
    };

    this.getAdvertisementById = function () {
        return $resource(baseURL + '/advertisement/:advertId', {
          advertId: 'advertId'
        });
    };

    this.submitAdvertisementById = function () {
        return $resource(baseURL + '/advertisement/release');
    };

    this.getDistrictsByCity = function () {
        return $resource(baseURL + '/advertisement/district/all');
    };

    this.removeAdvertisementById = function () {
        return $resource(baseURL + '/advertisement/remove');
    };

    this.parseAdvertisement = function (advertisement, i) {
        advertisement.number = i;
        var state = '未知'
        advertisement.catalog = this.types[advertisement.catalog];
        if (advertisement.status === '001') {
          state = '正常投放';
          advertisement.isDisableOff = true;
          advertisement.stateClass = "xmd-passed";
        } else if (advertisement.status === '010') {
          state = '草稿';
          advertisement.canSubmit = true;
          advertisement.isDisableModify = true;
          advertisement.stateClass = "xmd-draft";
        } else if (advertisement.status === '100') {
          state = '待审核';
          advertisement.isDisableCancel = true;
          advertisement.stateClass = "xmd-notSubmitted";
          advertisement.canCancel = true;
        } else if (advertisement.status === '000') {
          state = '审核未通过';
          advertisement.isDisableModify = true;
          advertisement.stateClass = "xmd-notPassed";
        } else if (advertisement.status === '101') {
          state = '广告被下架';
          addEventListener.isDisableModify = true;
          advertisement.stateClass = "xmd-removed";
        }
        advertisement.state = state;

        return advertisement;
    };

    this.formatAdvertisement = function (advertisement) {
      advertisement.city = 'Shanghai';

      // format date
      var startDay = moment(advertisement.startDate).toDate();
      var endDay = moment(advertisement.endDate).toDate();

      advertisement.startDate = startDay;
      advertisement.endDate = endDay;

      return advertisement;
    };

    this.parseDate = function (date) {
      var momentDate = moment(date);
      return momentDate.format('YYYY-MM-DD HH:mm:ss');
    }
  }
})();

/**
 * Created by LENOVO on 2016/3/29.
 */
(function () {
  'use strict';
  angular
    .module('mad')
    .controller('AdvertSatisticsCtrl', AdvertSatisticsCtrl);

  function AdvertSatisticsCtrl($scope, StatisticsSrv) {
    // $scope.totalPay = "111111";
    // $scope.totalTopUp = "222";
    // $scope.tableContent = [["123321245657","广告标题1","2016-01-01","100000","1000"],["123321245657","广告标题2","2016-02-01","200000","1500"]]
  
    $scope.advertCollection = [];
  
    StatisticsSrv.getAdvertisementStatistics().get().$promise
      .then(function (response) {
        if (response.errCode === 0) {
          console.log(response.advertisement);
          $scope.advertCollection = response.advertisement;
        }
      }, function (error) {
        console.log(error);
      });
  }


})();

/**
 * Created by Li on 2016/3/29.
 */
(function () {
  'use strict';
  angular
    .module('mad')
    .controller('NotificationCtrl', NotificationCtrl);

  function NotificationCtrl($scope, AdvertiserSrv) {
    var list;

    AdvertiserSrv.getMessages().get().$promise.then(function(response) {
      if (response.errCode === 0) {
        // console.log(response.messages);
        list = response.messages;
        list.forEach(function (message) {
          message.date = AdvertiserSrv.parseDateFromStr(message.date);
        });
        list.sort(function (a, b) {
            return b.date.getTime() - a.date.getTime();
        });
        list.forEach(function (message) {
          message.date = AdvertiserSrv.formatDate(message.date);
        });

        $scope.notificationContents = list;
      }
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('mad')
    .controller('MainCtrl', MainController);

// TODO: 发邮件功能，应该再加上用户邮箱；立即注册按钮的事件

  /** @ngInject */
  function MainController() {
  }
})();

(function () {
  'use strict';
  angular
    .module('mad')
    .controller('AdvertCtrl', AdvertCtrl);

  function AdvertCtrl($scope, $state, AdvertisementSrv, NoticeSrv) {
    var i = 0;
    $scope.advertList = [];
    $scope.itemsByPage = 10;
    $scope.advertCollection = [];

    // 获取广告信息
    AdvertisementSrv.getReleaseAdvertisement().get().$promise.then(function(response) {
        if (response.errCode === 0) {
          for (i = 0; i < response.advertisement.length; i += 1) {
            var advert = response.advertisement[i];
            $scope.advertList.push(AdvertisementSrv.parseAdvertisement(advert, i));
          }
          // console.log($scope.advertList);
          $scope.advertCollection = [].concat($scope.advertList);
        }
      }, function(error) {
        console.log('获取广告列表失败');
        NoticeSrv.error('获取广告列表失败');
      });
    $scope.advertCollection = [].concat($scope.advertList);

    //下架接口
    $scope.removeAdvertisementById = function (id) {
      AdvertisementSrv.removeAdvertisementById().save({
        id: id
      }).$promise.then(
        function (response) {
          console.log(response.errMessage);
          if (0 === response.errCode) {
            NoticeSrv.success("广告下架成功");
            
            $state.reload('app.advert');
          }
        }, function (error) {
          NoticeSrv.notice('未知错误:' + error);
        }
      );
    };

    
    //提交审核接口
    $scope.submitAdvertisementById = function (id) {
      if(id == null) {
        NoticeSrv.notice("广告ID有误");
        return;
      }
      //输入有效
      $scope.thereIsError = false;
      //发送请求
      AdvertisementSrv.submitAdvertisementById().get({
        id: id
      }).$promise.then(
        function (response) {
          console.log(response);
          if (0 == response.errCode) {
            NoticeSrv.success("广告提交审核成功");

            $state.reload('app.advert');
          } else {
            // 错误处理
            NoticeSrv.notice('未知错误:' + response.errCode);
          }
        }, function (error) {
          NoticeSrv.notice('未知错误:' + error);
        }
      );
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('mad')
    .controller('AdvertEditCtrl', AdvertEditCtrl);

  function AdvertEditCtrl($scope, $stateParams, $state, NoticeSrv, AdvertisementSrv) {
    $scope.advertTypes = AdvertisementSrv.advertTypes;
    $scope.advertCities = AdvertisementSrv.advertCities;

    var selectedBefore = [];

    if ('' !== $stateParams.advertId) {
      // 修改广告信息
      $scope.pageTitle = '修改广告';
      $scope.pageDetail = '';
      $scope.advertId = $stateParams.advertId;

      //获取广告详情
      AdvertisementSrv.getAdvertisementById().get({
        advertId: $scope.advertId
      }).$promise.then(function (response) {
        if (0 === response.errCode) {
          //console.log('advertDetail');
          //console.log(response.advertisement);

          //格式化数据
          $scope.advertisement = AdvertisementSrv.formatAdvertisement(response.advertisement);

          //获取商圈列表
          console.log($scope.advertisement.city);
          AdvertisementSrv.getDistrictsByCity().get({
            city: $scope.advertisement.city
          }).$promise.then(
            function (response) {
              if (response.errCode === 0) {
                var districts = response.broadcastLocation;
                var selected = $scope.advertisement.broadcastLocation;
                selectedBefore = $scope.advertisement.broadcastLocation;
                //检查selected状况并添加key
                districts.forEach(function (district) {
                  if (selected.indexOf(district.id) === -1) {
                    district["selected"] = false;
                  } else {
                    district["selected"] = true;
                  }
                });
                $scope.districts = districts;
              }
            }, function (error) {
              console.log('失败');
              console.log(error);
            });
        }
      }, function (error) {
        console.log('get advert detail error');
        console.log(error);
      });
    } else {
      // 新增广告
      // 修改标题
      $scope.pageTitle = '新增广告';
      $scope.pageDetail = '所有信息都必填';
      $scope.advertId = null;

      // 初始化广告数据
      $scope.advertisement = {
        city: 'Shanghai',
        catalog: 'other',
        price: '0'
      };

      AdvertisementSrv.getDistrictsByCity().get({
           city: $scope.advertisement.city
         }).$promise.then(
           function (response) {
             if (response.errCode === 0) {
               var districts = response.broadcastLocation;
               $scope.advertisement.broadcastLocation = [];
               //检查selected状况并添加key
               districts.forEach(function (district) {
                //  districtArray.push(district.id);
                 
                 district["selected"] = true;
                 $scope.advertisement.broadcastLocation.push(district.id);
                 selectedBefore.push(district.id);
               });
               $scope.districts = districts;
      
             }
           }, function (error) {
             console.log('失败');
             console.log(error);
           });
    }
    
    function wordCount(input) {
      var wordNum = 0;
      var contentArray = input.split(' ');
      var wordArray;
      contentArray.forEach(function (word) {
        if (word.search(/[\u4e00-\u9fa5]/g) !== -1) {
          // 有汉字，再切一次
          wordArray = word.split('');
          wordNum += wordArray.length;
        } else {
          wordNum += 1;
        }
      });
      return wordNum;
    }
    
    function districtCount(districts) {
      var num = 0;
      districts.forEach(function (district) {
        if (district.selected) {
          num += 1;
        }
      });
      return num;
    }
    
    function calculatePrice(fontNum, districtNum) {
      var price = (fontNum/districtNum);
      return price.toFixed(2);
    }
      
    $scope.changeContent = function (newVal) {
      if (newVal) {
        var wordNum = wordCount(newVal);
        var districtNum = districtCount($scope.districts);
        $scope.advertisement.price = calculatePrice(wordNum, districtNum);
        console.log($scope.advertisement.price);
      }
    };
    
    $scope.changeDistrict = function () {
      // 遍历districts
      var num = districtCount($scope.districts);
      if (num !== 0 && $scope.advertisement.content) {
        // 字数或者单词数
        var wordNum = wordCount($scope.advertisement.content);
        
        $scope.advertisement.price = calculatePrice(wordNum, num); 
      } else {
        $scope.advertisement.price = 0;
      }
      console.log($scope.advertisement.price);
    };

    //暂存草稿
    $scope.saveDraft = function() {
      $scope.check = {
        title: {
          isEmpty: false,
          isTooLong: false
        }, 
        content: {
          isEmpty: false,
          isTooLong: false
        },
        district: {
          isEmpty: false
        },
        startDate: {
          isEmpty: false
        }, 
        endDate: {
          isEmpty: false,
          earlyThanStart: false
        }
      };
      
      // 获取最后被选中的行政区
      var selectedArray = [];
      $scope.districts.forEach(function (district) {
        if (district.selected) {
          selectedArray.push(district.id);
        }
      });
      
      // 输入检查
      if ($scope.advertisement) {
        // title
        if (!$scope.advertisement.title) {
          $scope.check.title.isEmpty = true;
          return;
        } else {
          if (wordCount($scope.advertisement.title) > 20) {
            $scope.check.title.isTooLong = true;
            return;
          }
        }
        
        // content
        if (!$scope.advertisement.content) {
          $scope.check.content.isEmpty = true;
          return;
        } else {
          if (wordCount($scope.advertisement.content) > 60) {
            $scope.check.content.isTooLong = true;
            return;
          }
        }
        
        // district
        if (selectedArray.length < 1) {
          $scope.check.district.isEmpty = true;
          return;
        }
        
        // startDate
        if (!$scope.advertisement.startDate) {
          $scope.check.startDate.isEmpty = true;
          return;
        }
        
        // endDate
        if (!$scope.advertisement.endDate) {
          $scope.check.endDate.isEmpty = true;
          return;
        } else {
          if ($scope.advertisement.startDate.getTime() > $scope.advertisement.endDate.getTime()) {
            $scope.check.endDate.earlyThanStart = true;
            return;
          }
        }        
      } else {
        // 全部填true
        $scope.check = {
          title: {
            isEmpty: true,
            isTooLong: true
          }, 
          content: {
            isEmpty: true,
            isTooLong: true
          },
          district: {
            isEmpty: true
          },
          startDate: {
            isEmpty: true
          }, 
          endDate: {
            isEmpty: true,
            earlyThanStart: true
          }
        };
        
        return;
      }
      
       

      // 获取原先选中的行政区
      selectedBefore = $scope.advertisement.broadcastLocation;
      
      var advertisement = $scope.advertisement;

      var startDate = AdvertisementSrv.parseDate($scope.advertisement.startDate);
      var endDate = AdvertisementSrv.parseDate($scope.advertisement.endDate);
      
      // 往后端传,多加2个attribute: 1.add:新加的location 2.remove:减少的location
      var result = compareArray(selectedBefore, selectedArray);
      //console.log("selectedBefore:");
      //console.log(selectedBefore);
      //console.log("selectedArray:");
      //console.log(selectedArray);
      //console.log("added:");
      //console.log(result.add);
      //console.log("removed:");
      //console.log(result.remove);
      // console.log(typeof advertisement.price);
      advertisement.price = parseFloat(advertisement.price);
      
      // 发送请求
      AdvertisementSrv.saveDraftAdvertisement().save({
        "id": $scope.advertId,
        "title": advertisement.title,
        "content": advertisement.content,
        "catalog": advertisement.catalog,
        "broadcastLocation": selectedArray,
        "startDate": startDate,
        "endDate": endDate,
        "city": advertisement.city,
        "price": advertisement.price,
        "add": result.add,
        "remove": result.remove
      }).$promise.then(
        function (response) {
          if (response.errCode === 0) {
            console.log('保存草稿成功');
            console.log(response);
            // $('#successModal').modal('show');
            $state.go('app.advert.edit', {advertId: response.id});
            NoticeSrv.success('保存草稿成功');
          }

        }, function (error) {
          console.log('保存草稿失败');
          console.log(error);
        });
    };

    //审核提交
    $scope.submitApply = function() {
      console.log($scope.advertisement);
      if (!$scope.advertisement || !$scope.advertisement.title
        || !$scope.advertisement.content || !$scope.advertisement.catalog
        || !$scope.advertisement.city || !$scope.advertisement.startDate || !$scope.advertisement.endDate) {
        console.log('输入检查');

        return;
      }

      AdvertisementSrv.submitAdvertisementById().get({
        "id": $scope.advertId
      }).$promise.then(
        function (response) {
          if (response.errCode === 0) {
            $scope.resultTitle = '提交成功';
            $scope.resultDetail = '您的广告（编号为：'+$scope.advertId+'）已经提交至审核区，您可以在消息通知中查看审核结果，请耐心等待，谢谢！';
            $('#successModal').modal('show');
            console.log(response);
          }
          //  else {
          //   $scope.thereIsError = true;
          //   $scope.errMessage = '未知错误: '+response.errCode;
          // }
        }, function (error) {
          $scope.thereIsError = true;
          $scope.errMessage = '未知错误: '+error;
          console.log('提交失败');
          console.log(error);
        });
    };
    
    $('#successModal').on('hidden.bs.modal', function (e) {
      $state.go('app.advert');
    });

    /**
     * helper: 比较两个array并返回add和remove
     * @param before
     * @param after
     */
    var compareArray = function(before,after) {
      var add = new Array;
      var remove = new Array;
      // 对于每个after,如果不存在于before中,则添加入add数组
      after.forEach(function (aft) {
        if(before.indexOf(aft) === -1) {
          add.push(aft);
        }
      });
      // 对于每个before,如果不存在于after中,则添加入remove
      before.forEach(function (bef) {
        if(after.indexOf(bef) === -1) {
          remove.push(bef);
        }
      });
      return {
        add: add,
        remove: remove
      }
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('mad')
    .controller('AdvertDetailCtrl', AdvertDetailCtrl);

  function AdvertDetailCtrl($scope, $stateParams, AdvertisementSrv) {
    $scope.advertId = $stateParams.advertId;
        
    AdvertisementSrv.getAdvertisementById().get({
      advertId: $scope.advertId
    }).$promise.then(function (response) {
      if (0 === response.errCode) {
        console.log('advertDetail');
        console.log(response.advertisement);
        $scope.advertisement = AdvertisementSrv.parseAdvertisement(response.advertisement);
        
         AdvertisementSrv.getDistrictsByCity().get({city: $scope.advertisement.city}).$promise.then(
            function (response) {
              if (response.errCode === 0) {
                // Parse投放商圈
                var districts = response.broadcastLocation;
                var districtStr = '';
                $scope.advertisement.broadcastLocation.forEach(function (districtId) {
                  for (var i = 0; i < districts.length; i += 1) {
                    if (districts[i].id === districtId) {
                      districtStr += (districts[i].name + ',');
                      break;
                    }
                  }
                });
                districtStr = districtStr.substring(0, districtStr.length-1);
                $scope.locations = districtStr;
              }
            }, function (error) {
              console.log('失败');
              console.log(error);
            });
    
      }
    }, function (error) {
      console.log('get advert detail error');
      console.log(error);
    });
    
    
   
    
  }
})();

(function () {
  'use strict';
  angular
    .module('mad')
    .controller('AccountRefundCtrl', AccountRefundCtrl);

  function AccountRefundCtrl($scope, NoticeSrv, AdvertiserSrv) {

    // 广告商账户信息展示
    // TODO:广告商头像
    AdvertiserSrv.getAccountDetails().get().$promise.then(function(response) {
      if (response.errCode === 0) {
        $scope.alipay = response.advertiser.alipay;
        $scope.email = response.advertiser.email;
        $scope.name = response.advertiser.name;
        $scope.balance = response.advertiser.balance;
      }
    });

    // 显示余额
    $scope.getBalance = function getBalance() {
      $('#balance-btn').hide();
      $('#balance-label').show();
    };

    function getRefunds() {
      $scope.rowCollection = [];
      AdvertiserSrv.getRefundHistory().get().$promise.then(
        function (response) {
          var i = 0;
          var state = '';
          if (response.errCode === 0) {
            console.log('退款记录')
            console.log(response);
            for (i = 0; i < response.refundHistory.length; i++) {
              response.refundHistory[i].state = AdvertiserSrv.applyState[response.refundHistory[i].status];
              $scope.rowCollection.push(response.refundHistory[i]);
            }
          }
        }, function (error) {
          console.log('退款记录Error');
          console.log(error);
          NoticeSrv.error('退款申请提交失败');
        });
    }
    
    getRefunds();
    
    
    // 退款操作
    $scope.refund = function (amount, account) {
      if (!amount || !account) {
        // $scope.thereIsError = true;
        // $scope.errMessage = '';
        NoticeSrv.notice('请输入完整信息');
        return;
      }

      if (amount < 0) {
        // $scope.thereIsError = true;
        // $scope.errMessage = '';
        NoticeSrv.notice('请输入合法退款金额');
        return;
      }

      $scope.thereIsError = false;
      AdvertiserSrv.refund().save({
        refund: amount,
        Alipay: account
      }).$promise.then(
        function (response) {
          console.log(response);
          if (0 == response.errCode) {
            console.log('退款申请成功');
            // $('#successModal').modal('show');
            NoticeSrv.success('退款申请提交成功');
            getRefunds();
          } 
        }, function (error) {
          console.log('退款失败');
          console.log(error);
          // $scope.thereIsError = true;
          // $scope.errMessage = '未知错误:' + error;
          NoticeSrv.error('退款申请提交失败');
        }
      );
    }
  }
})();

(function () {
  'use strict';
  angular
    .module('mad')
    .controller('AccountRechargeCtrl', AccountRechargeCtrl);

  function AccountRechargeCtrl($scope, NoticeSrv, AdvertiserSrv) {

    $scope.checkbox = {
      trueValue : true
    };

    // 显示余额
    $scope.getBalance = function getBalance() {
      $('#balance-btn').hide();
      $('#balance-label').show();
    };

    function getRecharges() {
      $scope.rowCollection = [];

      AdvertiserSrv.getRechargeHistory().get().$promise.then(
        function (response) {
          var i = 0;
          var state = '';
          if (response.errCode === 0) {
            console.log('充值记录')
            console.log(response);
            for (i = 0; i < response.rechargeHistory.length; i++) {
              response.rechargeHistory[i].state = AdvertiserSrv.applyState[response.rechargeHistory[i].status];
              $scope.rowCollection.push(response.rechargeHistory[i]);
            }
          }
        }, function (error) {
          console.log('充值记录Error');
          console.log(error);
        });
    }
    getRecharges();

    // 广告商账户信息展示
    // TODO:广告商头像
    AdvertiserSrv.getAccountDetails().get().$promise.then(function(response) {
      if (response.errCode === 0) {
        $scope.alipay = response.advertiser.alipay;
        $scope.email = response.advertiser.email;
        $scope.name = response.advertiser.name;
        $scope.balance = response.advertiser.balance;
      }
    });

    // 显示账户充值二维码
    $scope.recharge = function (account, amount) {
      if(!account || !amount) {
        // $scope.thereIsError = true;
        // $scope.errMessage = '请输入完整信息';
        NoticeSrv.notice('请输入完整信息');
      } else {
        $scope.thereIsError = false;
        // 根据amount显示modal图片
        console.log(typeof amount);
        if(typeof amount === "string") {
          amount = parseInt(amount);
          console.log(typeof amount);
        }
        switch (amount) {
          case 50:
            $scope.qrCodeImage = "http://mad-10035512.file.myqcloud.com/50.jpg";
            break;
          case 100:
            $scope.qrCodeImage = "http://mad-10035512.file.myqcloud.com/100.jpg";
            break;
          case 200:
            $scope.qrCodeImage = "http://mad-10035512.file.myqcloud.com/200.jpg";
            break;
          case 500:
            $scope.qrCodeImage = "http://mad-10035512.file.myqcloud.com/500.jpg";
            break;
          default :
        }
        $('#qrCodeModal').modal('show');
      }
    };

    // 充值申请
    $scope.rechargeFinish = function(account, amount) {
      if(typeof amount === "string") {
        amount = parseInt(amount);
        console.log(typeof amount);
      }
      AdvertiserSrv.recharge().save({
        recharge: amount,
        Alipay: account
      }).$promise.then(
        function (response) {
          console.log(response);
          if (0 == response.errCode) {
            console.log('充值申请成功');
            $('#qrCodeModal').modal('hide');
            // $('#successModal').modal('show');
            NoticeSrv.success('充值成功');
            getRecharges();
          }
        }, function (error) {
          console.log('充值失败');
          console.log(error);
          // $scope.thereIsError = true;
          // $scope.errMessage = '未知错误:' + error;
          NoticeSrv.error('充值失败');
        });
    };
  }
})();

(function() {
  'use strict';
  angular
    .module('mad')
    .controller('AccountCheckCtrl', AccountCheckCtrl);

    /** @ngInject */
  function AccountCheckCtrl($scope, $state, $log, $qupload, $window, AdvertiserSrv, NoticeSrv) {

    // 获取图片上传token
    AdvertiserSrv.getUpToken().get().$promise.then(
      function (response) {
        if (response.errCode === 0) {
          $window.localStorage['upToken'] = response.uptoken;
          // console.log('uptoken:  ' + $window.localStorage['upToken']);
        }
      }).catch(function (error) {
        NoticeSrv.error('未知错误');
      });


    // 上传图片
    $scope.selectFiles = [];
      console.log($window.localStorage['upToken']);
  		var start = function (index) {
  			$scope.selectFiles[index].progress = {
  				p: 0
  			};
  			$scope.selectFiles[index].upload = $qupload.upload({
  				key: $scope.selectFiles[index].file.name.split('.')[0],
  				file: $scope.selectFiles[index].file,
          token: $window.localStorage['upToken']
  			});
  			$scope.selectFiles[index].upload.then(function (response) {
  				$log.info(response);
          $scope.upload = {
            result: '上传成功',
            picUrl: 'http://o7epbv9gm.bkt.clouddn.com/' + response.key,
            isSuccess: true
          }
  			}, function (response) {
  				$log.info(response);
          $scope.upload = {
            result: '上传失败',
            isSuccess: false
          }
  			}, function (evt) {
  				$scope.selectFiles[index].progress.p = Math.floor(100 * evt.loaded / evt.totalSize);
  			});
  		};

  		$scope.abort = function (index) {
  			$scope.selectFiles[index].upload.abort();
  			$scope.selectFiles.splice(index, 1);
  		};

  		$scope.onFileSelect = function ($files) {
  			var offsetx = $scope.selectFiles.length;
  			for (var i = 0; i < $files.length; i++) {
  				$scope.selectFiles[i + offsetx] = {
  					file: $files[i]
  				};
  				start(i + offsetx);
  			}
  		}


    AdvertiserSrv.getCheckDetail().get().$promise.then(
      function (response) {

        if (response.errCode === 0) {
          if (response.detail) {
            // console.log(response.detail);
            // 有验证信息，把数据填到页面上，disabled掉提交按钮
            var detail = AdvertiserSrv.parseCheckInfo(response.detail);
            console.log(detail);

            $scope.checkStatus = {
              'unsubmitted': false
            };

            if (detail.status === '100') {
              $scope.checkStatus.submitted = false;
              $scope.checkStatus.completedCheck = true;
            } else {
              $scope.checkStatus.submitted = true;
              $scope.checkStatus.completedCheck = false;
            }


            $scope.detail = {
              companyType: detail.type,
              licenseType: detail.licenseType,
              companyName:detail.companyName,
              licenseCode:detail.licenseCode,
              companyLocationProvince: detail.companyLocationProvince,
              companyLocationDistrict: detail.companyLocationDistrict,
              accomodation:detail.accomodation,
              businessScope:detail.businessScope,
              businessPeriod: detail.periodDate,
              periodIsLong: detail.periodIsLong,
              organizationCode: detail.organizationCode,
              legalPersonName: detail.legalPerson.name,
              legalPersonLocation: detail.legalPerson.location,
              legalPersonId: detail.legalPerson.id,
              legalPersonValidDate: detail.legalPerson.idValidDate,
              legalPersonIdIsLong: detail.legalPerson.iflongterm,
              legalPersonIflegalperson: detail.legalPerson.iflegalperson,
              contactEmail: detail.contactEmail,
              licenseImageUrl: detail.licenseImageUrl
            };
          } else {
            $scope.checkStatus = {
              'unsubmitted': true
            };
          }
        }
      },function (error) {
        console.log(error);
      });


    $scope.submit = function () {
      // 输入检查
      if (!$scope.detail || !checkInfoValid($scope.detail)) {
        // console.log('输入检查');
        // console.log($scope.detail);
        NoticeSrv.notice('请输入合法信息');
        return;
      }

      // 格式化数据
      var detail = AdvertiserSrv.formatCheckInfo($scope.detail);
      // console.log(detail);

      AdvertiserSrv.checkInfo().save({
        "detail": {
            "type": detail.companyType,
            "licenseType": detail.licenseType,
            "companyName": detail.companyName,
            "licenseCode": detail.licenseCode,
            "licenseImageUrl": $scope.upload.picUrl,
            "location": detail.companyLocationProvince + ',' + detail.companyLocationDistrict,
            "accomodation": detail.accomodation,
            "businessScope": detail.businessScope,
            "businessPeriod": detail.businessPeriodStr,
            "periodIsLong": detail.periodIsLong,
            "organizationCode": detail.organizationCode,
            "legalPerson": {
                "name": detail.legalPersonName,
                "location": detail.legalPersonLocation,
                "id": detail.legalPersonId,
                "validDate": detail.legalPersonValidDateStr,
                "iflongterm": detail.legalPersonIdIsLong,
                "iflegalperson": detail.legalPersonIflegalperson
            },
            "contactEmail": detail.contactEmail
        }
      }).$promise.then(
        function (response) {
          if (response.errCode === 0) {
            // console.log('提交checkInfo成功');
            // console.log(response);
            NoticeSrv.success('提交验证信息成功');
            $state.go('app.account.check', {reload: true});
          }
        }, function (error) {
          // console.log('提交checkInfo失败');
          // console.log(error);
        });
    }
  }

  function checkInfoValid(detail) {
    if (detail.accomodation && detail.businessScope
      && detail.companyLocationDistrict
      && detail.companyLocationProvince && detail.companyName
      && detail.companyType && detail.contactEmail
      && detail.legalPersonId && detail.legalPersonIflegalperson
      && detail.legalPersonLocation && detail.legalPersonName
      && detail.licenseCode
      && detail.licenseType && detail.organizationCode) {
        if ((detail.businessPeriod || detail.periodIsLong) && (detail.legalPersonValidDate || detail.legalPersonIdIsLong)) {

          // 不能日期和长期都填
          if (detail.businessPeriod && detail.periodIsLong) {
            return false;
          }
          if (detail.legalPersonValidDate && detail.legalPersonIdIsLong) {
            return false;
          }
          return true;
        }
    }
    return false;
  }
})();

(function() {
  'use strict';
  angular
    .module('mad')
    .controller('AccountCtrl', AccountCtrl);

  /** @ngInject */
  function AccountCtrl($scope, $state, NoticeSrv, AdvertiserSrv) {
    angular.module('tabsDemoDynamicHeight', ['ngMaterial']);
    //获取账户信息
    AdvertiserSrv.getAccountDetails().get().$promise.then(function(response) {
      if (response.errCode === 0) {
        $scope.alipay = response.advertiser.alipay;
        $scope.email = response.advertiser.email;
        $scope.name = response.advertiser.name;
        var status = response.advertiser.status;
        if (status === "010") { //未审核
          $scope.notVerified = true;
          $scope.isPassed = false;
          $scope.notPassed = false;
        } else if (status === "100") {
          $scope.notVerified = false;
          $scope.isPassed = true;
          $scope.notPassed = false;
        } else {
          $scope.notVerified = false;
          $scope.isPassed = false;
          $scope.notPassed = true;
        }
      }
    }, function (error) {
      NoticeSrv.error('未能获取用户信息');
      console.log(error);
    });
    //修改支付宝的接口
    $scope.changeAlipay = function (alipay) {
      //验证输入有效性
      if(!alipay) {
        $scope.thereIsError = true;
        $scope.errMessage = '请输入完整信息';
        return;
      }
      if(alipay === $scope.alipay) {
        $scope.thereIsError = true;
        $scope.errMessage = '输入的支付宝账号与现在账号相同';
        return;
      }
      //输入有效
      $scope.thereIsError = false;
      //发送请求
      AdvertiserSrv.changeAlipay().save({
        Alipay: alipay
      }).$promise.then(
        function (response) {
          console.log(response);
          if (0 === response.errCode) {
            $scope.resultDetail = "您的支付宝账户名称更改成功";
            $('#successModal').modal('show');
            $scope.alipay = alipay;
          }
          // else {
          //   // 错误处理
          //   $scope.thereIsError = true;
          //   $scope.errMessage = '未知错误:' + response.errCode;
          // }
        }, function (error) {
          NoticeSrv.error('未知错误');

          // $scope.thereIsError = true;
          // $scope.errMessage = '未知错误:' + error;
        }
      );
    };
    //修改密码接口
    $scope.changePassword = function(oldPwd,newPwd,confirmPwd) {
      //验证输入有效性
      if(newPwd.length < 8) {
        $scope.newPwdError = true;
        $scope.newErrMsg = '密码至少要8位';
        return;
      }

      $scope.newPwdError = false;

      if(!oldPwd || !newPwd || !confirmPwd) {
        $scope.confirmPwdError = true;
        $scope.confirmErrMsg = '请输入完整信息';
        return;
      }

      if(confirmPwd !== newPwd) {
        $scope.confirmPwdError = true;
        $scope.confirmErrMsg = '再次输入的密码不正确，请重新输入';
        return;
      }
      if(newPwd === oldPwd) {
        $scope.confirmPwdError = true;
        $scope.confirmErrMsg = '密码没有改变，请重新输入';
        return;
      }
      //输入有效
      $scope.confirmPwdError = false;

      //发送请求
      var oldPassSHA256 = sha256(oldPwd);
      var newPassSHA256 = sha256(newPwd);

      AdvertiserSrv.changePassword().save({
        oldPwd: oldPassSHA256,
        newPwd: newPassSHA256
      }).$promise.then(
        function (response) {
          console.log(response);
          if (0 === response.errCode) {
            $scope.oldPwdError = false;
            $scope.resultDetail = "您的密码修改成功";
            $('#successModal').modal('show');

          } else if (305 === response.errCode) {
            $scope.oldPwdError = true;
            $scope.oldErrMsg = '旧密码错误，请重新输入';
          }
          // else {
          //   // 错误处理
          //   if (305 == response.errCode) {
              // $scope.oldPwdError = true;
              // $scope.oldErrMsg = '旧密码错误，请重新输入';
          //   } else {
          //     $scope.confirmPwdError = true;
          //     $scope.confirmErrMsg = '未知错误:' + response.errCode;
          //   }
          // }
        }, function (error) {
          NoticeSrv.error('未知错误');
          // $scope.confirmPwdError = true;
          // $scope.confirmErrMsg = '未知错误:' + error;
        });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('mad')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('mad')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('app', {
        url: '/',
        views: {
            'header': {
                templateUrl: 'app/components/navbar-advert/navbar-advert.html',
                controller: 'HeaderCtrl'
            },
            'content': {
                templateUrl: 'app/main/main.html',
                controller: 'MainCtrl'
            },
            'footer': {
              templateUrl: 'app/components/footer-advert/footer-advert.html',
              controller: 'FooterCtrl'
            }
        }
      })
      .state('app.advert', {
        url: 'advert',
        views: {
            'content@': {
                templateUrl: 'app/advertisment/advertisment.html',
                controller: 'AdvertCtrl'
            }
        }
      })
      .state('app.advert.edit', {
        url: '/edit/:advertId',
        views: {
            'content@': {
                templateUrl: 'app/advert-edit/advert-edit.html',
                controller: 'AdvertEditCtrl'
            }
        }
      })
      .state('app.advert.detail', {
        url: '/detail/:advertId',
        views: {
            'content@': {
                templateUrl: 'app/advert-detail/advert-detail.html',
                controller: 'AdvertDetailCtrl'
            }
        }
      })
      .state('app.account', {
          url: 'account',
          views: {
              'content@': {
                  templateUrl: 'app/account/account.html',
                  controller: 'AccountCtrl'
              }
          }
      })
      .state('app.account.recharge', {
          url: '/recharge',
          views: {
              'content@': {
                  templateUrl: 'app/account-recharge/account-recharge.html',
                  controller: 'AccountRechargeCtrl'
              }
          }
      })
      .state('app.account.refund', {
          url: '/refund',
          views: {
              'content@': {
                  templateUrl: 'app/account-refund/account-refund.html',
                  controller: 'AccountRefundCtrl'
              }
          }
      })
      .state('app.account.check', {
          url: '/check',
          views: {
              'content@': {
                  templateUrl: 'app/account-check/account-check.html',
                  controller: 'AccountCheckCtrl'
              }
          }
      })
      .state('app.statistics', {
          url: 'statistics',
          views: {
              'content@': {
                  templateUrl: 'app/statistics/statistics.html',
                  controller: 'AdvertSatisticsCtrl'
              }
          }
      })
      .state('app.statistics.advertis', {
          url: '/advertis',
          views: {
              'content@': {
                  templateUrl: 'app/statistics-advertis/statistics-advertis.html',
                  controller: 'SatisticsAdvertMapCtrl'
              }
          }
      })
      .state('app.statistics.detail', {
          url: '/detail/:advertId',
          views: {
              'content@': {
                  templateUrl: 'app/statistics-detail/statistics-detail.html',
                  controller: 'SatisticsDetailCtrl'
              }
          }
      })
      .state('app.notification', {
          url: 'notification',
          views: {
              'content@': {
                  templateUrl: 'app/notification/notification.html',
                  controller: 'NotificationCtrl'
              }
          }
      })
      .state('app.pact', {
          url: 'pact',
          views: {
              'content@': {
                  templateUrl: 'app/pact/pact.html'
              }
          }
      });
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('mad')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('mad')
    .config(config);

  /** @ngInject */
  function config($httpProvider, $logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);
    $httpProvider.interceptors.push('myInterceptor');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

  angular.module('mad').value('baseURL', 'http://121.42.57.59:4000/advertiser');
  // 测试
  // angular.module('mad').value('baseURL', 'http://localhost:4000/advertiser');
})();

angular.module("mad").run(["$templateCache", function($templateCache) {$templateCache.put("app/account/account.html","<div class=\"container\"><div class=\"text-center\"><h1>个人账号中心</h1><hr></div><div class=\"col-md-offset-1 col-md-10\"><div class=\"row\"><div class=\"col-md-3 col-sm-5\"><div class=\"panel panel-default\"><div class=\"panel-body text-center\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-2 col-xs-6 col-xs-offset-3\"><img src=\"assets/images/avatar.jpg\" class=\"img-responsive img-circle\"></div></div><h4>{{name}}</h4><p>{{email}}</p><span class=\"label label-success\" ng-show=\"isPassed\">已通过审核</span><div ng-show=\"notVerified\"><span class=\"label label-warning\">未审核</span> <button ui-sref=\"app.account.check\" class=\"btn btn-info btn-xs\">审核</button></div><div ng-show=\"notPassed\"><span class=\"label label-danger\">未通过审核</span> <button ui-sref=\"app.account.check\" class=\"btn btn-info btn-xs\">再次审核</button></div></div></div></div><div class=\"col-md-9 col-sm-7 tab-content\"><div class=\"panel panel-default\"><div class=\"panel-body xmd-body\"><h4>修改密码</h4><hr style=\"margin-top: 15px;\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">旧密码</label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" ng-model=\"oldPwd\"> <span class=\"text-red\" ng-show=\"oldPwdError\">{{oldErrMsg}}</span></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">新密码</label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" ng-model=\"newPwd\"> <span class=\"text-red\" ng-show=\"newPwdError\">{{newErrMsg}}</span></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">再次输入新密码</label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" ng-model=\"confirmPwd\"> <span class=\"text-red\" ng-show=\"confirmPwdError\">{{confirmErrMsg}}</span></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-info\" ng-click=\"changePassword(oldPwd,newPwd,confirmPwd)\">修改密码</button></div></div></form><br><h4>修改支付宝帐号</h4><hr style=\"margin-top: 15px;\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">支付宝账号</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" placeholder=\"{{alipay}}\" ng-model=\"currentAlipay\"> <span class=\"text-red\" ng-show=\"thereIsError\">{{errMessage}}</span></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-warning\" ng-click=\"changeAlipay(currentAlipay)\">修改支付宝帐号</button></div></div></form><br></div></div></div></div></div></div><div class=\"modal fade bs-example-modal-sm\" id=\"successModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel2\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel2\">修改成功</h4></div><div class=\"modal-body\">{{resultDetail}}</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">关闭</button></div></div></div></div>");
$templateCache.put("app/account-check/account-check.html","<div class=\"container\"><div class=\"text-center\" ng-show=\"checkStatus.unsubmitted\"><h1>广告商认证</h1><p>您需要通过认证才可以发表广告</p><hr></div><div class=\"text-center\" ng-show=\"checkStatus.submitted\"><h1>广告商认证</h1><h3>您的审核信息已提交，请不要重复提交审核信息</h3><hr></div><div class=\"text-center\" ng-show=\"checkStatus.completedCheck\"><h1>广告商认证</h1><h3>您的审核信息已验证成功，请不要重复提交审核信息</h3><hr></div><div class=\"col-md-offset-2 col-sm-8 col-sm-offset-1 col-sm-10\"><form class=\"form-horizontal\" name=\"checkInfo\"><h4>单位类型</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">选择单位类型</label><div class=\"col-sm-10\"><div class=\"col-sm-4 col-xs-6\"><label><input type=\"radio\" name=\"company-type\" ng-model=\"detail.companyType\" value=\"企业\"> 企业</label></div><div class=\"col-sm-4 col-xs-6\"><label><input type=\"radio\" name=\"company-type\" ng-model=\"detail.companyType\" value=\"事业单位\"> 事业单位</label></div><div class=\"col-sm-4 col-xs-6\"><label><input type=\"radio\" name=\"company-type\" ng-model=\"detail.companyType\" value=\"民办非企业单位\"> 民办非企业单位</label></div><div class=\"col-sm-4 col-xs-6\"><label><input type=\"radio\" name=\"company-type\" ng-model=\"detail.companyType\" value=\"个体工商户\"> 个体工商户</label></div><div class=\"col-sm-4 col-xs-6\"><label><input type=\"radio\" name=\"company-type\" ng-model=\"detail.companyType\" value=\"社会团体\"> 社会团体</label></div><div class=\"col-sm-4 col-xs-6\"><label><input type=\"radio\" name=\"company-type\" ng-model=\"detail.companyType\" value=\"党政及国家机关\"> 党政及国家机关</label></div></div></div><div class=\"form-group\"><div class=\"col-sm-3 col-sm-offset-3 text-center\"><img src=\"http://mad-10035512.file.myqcloud.com/license.JPG\" height=\"150px\"> <label>普通营业执照</label></div><div class=\"col-sm-3 col-sm-offset-1 text-center\"><img src=\"http://mad-10035512.file.myqcloud.com/marginLicense.jpg\" height=\"150px\"> <label>多证合一营业执照</label></div></div><h4>企业信息</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">证件类型</label><div class=\"col-sm-10\"><div class=\"radio\"><label><input type=\"radio\" name=\"license-type\" ng-model=\"detail.licenseType\" value=\"普通营业执照\"> 普通营业执照（存在独立的组织机构代码证）</label></div><div class=\"radio\"><label><input type=\"radio\" name=\"license-type\" ng-model=\"detail.licenseType\" value=\"多证合一营业执照\"> 多证合一营业执照（不存在独立的组织机构代码证）</label></div></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">企业名称</label><div class=\"col-sm-10\"><input class=\"form-control\" ng-model=\"detail.companyName\" placeholder=\"企业全称，与营业执照上一致\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">注册号</label><div class=\"col-sm-10\"><input class=\"form-control\" ng-model=\"detail.licenseCode\" placeholder=\"如：111112222233333\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">单位所在地</label><div class=\"col-sm-5\"><select class=\"form-control\" ng-model=\"detail.companyLocationProvince\"><option>请选择</option><option>上海</option><option>江苏</option></select></div><div class=\"col-sm-5\"><select class=\"form-control\" ng-model=\"detail.companyLocationDistrict\"><option>请选择</option><option>黄浦区</option><option>嘉定区</option></select></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">住所</label><div class=\"col-sm-10\"><input class=\"form-control\" ng-model=\"detail.accomodation\" placeholder=\"\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">经营范围</label><div class=\"col-sm-10\"><input class=\"form-control\" ng-model=\"detail.businessScope\" placeholder=\"\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">营业期限</label><div class=\"col-sm-3\"><input class=\"form-control\" type=\"date\" ng-model=\"detail.businessPeriod\"></div><div class=\"col-sm-7\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"detail.periodIsLong\">长期</label></div></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">组织机构代码</label><div class=\"col-sm-10\"><input class=\"form-control\" ng-model=\"detail.organizationCode\" placeholder=\"如：00001111-1\"></div></div><br><h4>法定代表人信息</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">法定代表人归属地</label><div class=\"col-sm-10\"><select class=\"form-control\" ng-model=\"detail.legalPersonLocation\"><option value=\"中国大陆\">中国大陆</option><option value=\"香港\">香港</option><option value=\"澳门\">澳门</option><option value=\"台湾\">台湾</option><option value=\"海外\">海外</option></select></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">法定代表人姓名</label><div class=\"col-sm-10\"><input class=\"form-control\" ng-model=\"detail.legalPersonName\" placeholder=\"\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">身份证号</label><div class=\"col-sm-10\"><input class=\"form-control\" ng-model=\"detail.legalPersonId\" placeholder=\"\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">证件有效期</label><div class=\"col-sm-3\"><input class=\"form-control\" type=\"date\" ng-model=\"detail.legalPersonValidDate\"></div><div class=\"col-sm-7\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"detail.legalPersonIdIsLong\">长期</label></div></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">填写人身份</label><div class=\"col-sm-10\"><div class=\"col-xs-6 radio\"><label><input type=\"radio\" name=\"fill-person\" ng-model=\"detail.legalPersonIflegalperson\" value=\"true\">我是法定代表人</label></div><div class=\"col-xs-6 radio\"><label><input type=\"radio\" name=\"fill-person\" ng-model=\"detail.legalPersonIflegalperson\" value=\"false\">我是代理人</label></div></div></div><br><h4>联系方式</h4><hr style=\"margin-top:10px;\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">联系人邮箱</label><div class=\"col-sm-10\"><input class=\"form-control\" ng-model=\"detail.contactEmail\" placeholder=\"验证结果将通过邮件发送至该邮箱\"></div></div><h4>上传营业执照</h4><hr style=\"margin-top:10px;\"><div></div><img src=\"{{detail.licenseImageUrl}}\" class=\"img-rounded center-block\" style=\"width:60%;margin-bottom:20px\" alt=\"\"><div class=\"widget-body\" ng-show=\"!detail.licenseImageUrl\"><form class=\"form-horizontal no-margin\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">上传图片</label><div class=\"col-sm-10\"><button ng-file-select=\"onFileSelect($files)\" class=\"btn btn-large btn-primary btn-upload\" data-multiple=\"true\" title=\"select file\" onclick=\"this.value = null\" ng-disabled=\"detail.licenseImageUrl\">点击此处选择图片</button><ol><li ng-repeat=\"(k,v) in selectFiles\">{{v.file.name}} - {{v.progress.p}}% <button ng-click=\"abort(k)\">x</button></li></ol><label>{{upload.result}}</label> <a href=\"{{upload.picUrl}}\" ng-show=\"upload.isSuccess\">点击查看</a></div></div></form></div><hr style=\"margin-top:10px;\"><div class=\"text-center\"><button class=\"btn btn-primary\" ng-disabled=\"!canSubmit\" ng-click=\"submit()\">提交申请</button></div></form></div></div>");
$templateCache.put("app/account-refund/account-refund.html","<div class=\"container\"><div class=\"container jx-container\"><div class=\"row\"><div class=\"col-md-offset-2 col-md-8\"><h2 class=\"text-center\">账户退款</h2><p class=\"text-center\">您可以将已充值的金额提现</p><hr><div class=\"row\"><div class=\"panel panel-success\"><div class=\"panel-heading\"><h3 class=\"panel-title text-center\">退款</h3></div><div class=\"panel-body\"><div class=\"col-sm-9 recharge-part\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"\" class=\"col-sm-3 control-label\">退款金额</label><div class=\"col-sm-8\"><input type=\"number\" class=\"form-control\" placeholder=\"请输入整数，单位为元\" ng-model=\"amount\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\" for=\"\">退款账户</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" placeholder=\"请输入支付宝账户\" ng-model=\"account\"> <span class=\"text-red\" ng-show=\"thereIsError\">{{errMessage}}</span></div></div><div><button type=\"submit\" class=\"btn btn-success center-block btn-fluid\" ng-click=\"refund(amount, account)\">申请退款</button></div></form></div><div class=\"col-sm-3\"><div class=\"ht-user-info row\"><div class=\"col-sm-12 text-center\"><h4 for=\"\">{{name}}</h4><p><small>{{email}}</small></p><button class=\"btn btn-primary\" id=\"balance-btn\" ng-click=\"getBalance()\">查看账户余额</button><p id=\"balance-label\" hidden=\"\"><b>余额：</b>{{balance}}</p></div></div></div></div></div></div><div class=\"row\"><h3 class=\"ht-charge-title\">退款记录</h3><p class=\"text-center\">查看您的历史退款记录</p><hr style=\"margin-top: 15px;\"></div><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-body\"><table class=\"table table-hover\" st-table=\"rowCollection\"><thead><tr><th>退款金额（元）</th><th>退款账户</th><th>退款时间</th><th>退款状态</th></tr></thead><tbody><tr ng-repeat=\"row in rowCollection\"><td>{{ row.amount }}</td><td>{{ row.account }}</td><td>{{ row.time }}</td><td>{{ row.state }}</td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/account-recharge/account-recharge.html","<div class=\"container\"><div class=\"container jx-container\"><div class=\"row\"><div class=\"col-md-offset-2 col-md-8\"><h2 class=\"text-center\">账户充值</h2><p class=\"text-center\">为确保您的广告正常播放，请经常查看余额或充值</p><hr><div class=\"row\"><div class=\"panel panel-success\"><div class=\"panel-heading\"><h3 class=\"panel-title text-center\">充值</h3></div><div class=\"panel-body\"><div class=\"col-sm-9 recharge-part\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"singleSelect\" class=\"col-sm-3 control-label\">充值金额</label><div class=\"col-sm-8\"><select name=\"singleSelect\" id=\"singleSelect\" class=\"form-control\" ng-model=\"amount\"><option value=\"\">---请选择---</option><option value=\"50\">50</option><option value=\"100\">100</option><option value=\"200\">200</option><option value=\"500\">500</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">支付宝帐号</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" placeholder=\"输入与转账相符的支付宝账户\" ng-model=\"account\"> <span class=\"text-red\" ng-show=\"thereIsError\">{{errMessage}}</span></div></div><div class=\"form-group\"><div class=\"col-sm-offset-1 col-sm-10\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"checkbox.trueValue\">已阅读并同意<a type=\"button\" data-toggle=\"modal\" data-target=\"#pactModal\">广告发布协议</a></label></div></div></div><div><button type=\"submit\" class=\"btn btn-success center-block btn-fluid\" ng-click=\"recharge(account, amount)\">充值</button></div></form></div><br><div class=\"col-sm-3\"><div class=\"ht-user-info row\"><div class=\"col-sm-12 text-center\"><h4 for=\"\">{{name}}</h4><p><small>{{email}}</small></p><button class=\"btn btn-primary\" id=\"balance-btn\" ng-click=\"getBalance()\">查看账户余额</button><p id=\"balance-label\" hidden=\"\"><b>余额：</b>{{balance}}</p></div></div></div></div></div></div><div class=\"row\"><h3 class=\"ht-charge-title\">充值记录</h3><p class=\"text-center\">查看您的历史充值记录</p><hr style=\"margin-top: 15px;\"></div><div class=\"row\"><div class=\"panel panel-default\"><div class=\"panel-body\"><table class=\"table table-hover\" st-table=\"rowCollection\"><thead><tr><th>充值金额（元）</th><th>充值账户</th><th>充值时间</th><th>充值状态</th></tr></thead><tbody><tr ng-repeat=\"row in rowCollection\"><td>{{ row.amount }}</td><td>{{ row.account }}</td><td>{{ row.time }}</td><td>{{ row.state }}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"modal fade bs-example-modal-sm\" id=\"qrCodeModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">充值</h4></div><div class=\"modal-body\"><div class=\"text-center\"><img src=\"{{qrCodeImage}}\" class=\"img-responsive qrcode-img\"> <button class=\"btn btn-success\" ng-click=\"rechargeFinish(account, amount)\">转账成功后点击这里</button></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">关闭</button></div></div></div></div><div class=\"modal fade bs-example-modal\" id=\"pactModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel2\"><div class=\"modal-dialog modal-lg\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel2\">车载广告服务协议</h4></div><div class=\"modal-body\"><h4>甲方:广告投放方</h4><h4>乙方:MAD移动广告投放平台</h4><p>双方本着友好协商、共同发展的原则，由乙方在网站，为甲方提供网络广告服务。</p><h4>一、服务内容</h4><ol><li>广告类型：本条所指广告内容是指甲方拟在乙方公司内所有广告载体上发布的有关甲方业务的信息，广告形式为静态文字。文字长最长不超过60字。</li><li>乙方将在乙方公司内符合投放条件的车载广告播放装置上发布甲方的广告内容</li></ol><h4>二、甲方的权利义务</h4><ol><li>甲方所要宣传的内容如有变动必须向乙方提交审核，以便乙方能及时调整更新广告信息。</li><li>甲方有权根据本合同第一条所要求的服务内容及标准，检查乙方提供的广告服务质量，如乙方提供的服务质量不符合本合同第一条的规定，甲方有权要求乙方在规定时间内做出补充和修正。</li><li>甲方发布的广告内容必须符合中国法律法规的规定，不得委托乙方发布国家明令禁止的广告内容。</li><li>甲方必须保证所发布广告的真实性、有效性，并独立承担责任。</li><li>甲方必须依据本合同规定，按时足额向乙方支付广告服务款项。</li></ol><h4>三、乙方的权利义务</h4><ol><li>乙方必须严格遵守中华人民共和国广告法及相关适用法律的相关规定及要求发布广告；</li><li>乙方必须按本合同规定第一条规定的服务内容及标准向甲方提供广告服务；</li><li>乙方有权要求甲方按其规定提供营业执照、资质证明等相关证明材料，甲方拒不提供的，乙方有权拒绝为其发布广告。</li><li>乙方一旦发现甲方提供的广告存在虚假成分，有权立即单方面撤除广告，并通知甲方澄清事实。由此造成的损失由甲方承担。</li><li>乙方有权要求甲方按时足额支付广告服务费用；</li></ol><h4>四、违约责任</h4><ol><li>双方中任何一方违反本合同的规定，均必须承担相应的法律责任，赔偿对方因此而造成的经济损失。</li><li>如乙方未能在本合同规定时间内，为甲方提供广告服务，每延迟一天，乙方须减收甲方广告服务费用总额的1%的作为补偿，如延迟时间超过一个月，甲方有权要求终止合同，乙方将向甲方退回全部预付款。</li><li>如甲方未能在本合同规定时间内，向乙方支付预付款及余款，每延迟一天，甲方须向乙方支付广告服务费用总额1%的赔偿金，如延迟时间超过一个月时间，乙方有权终止合同，并有权要求甲方赔偿广告服务费用总额双倍的经济赔偿金。</li><li>由于甲方提供广告中存在虚假成分，或因此引发第三方法律诉讼，要求经济赔偿等，甲方必须独立承担全部损失，并赔偿由此给乙方造成的一切名誉和经济损失。</li></ol><h4>五、服务费用</h4><ol><li>服务付费：单条广告价格根据乙方所投放广告自动计算得出，在广告投放时广告费用自动从乙方账户中扣除；</li><li>支付方式：乙方在投放广告前需向账户中充值足够金额以投放广告，所充值金额会自动兑换为等值MAD币。</li></ol><h4>六、知识产权</h4><ol><li>在本合同执行过程中而产生的广告作品著作权归制作方所有，即由甲方设计制作的广告作品著作权归甲方所有，由甲方委托乙方设计制作的广告作品著作权归乙方所有。</li></ol><h4>七、合同终止</h4><ol><li>如甲方不能提供广告相关商品或服务的资质证明、产品说明书或政府主管部门的审批文件，或提供的上述材料中存在虚假成分，或因此第三方的法律诉讼、经济索赔要求等情况，乙方有权终止本合同，且不承担任何责任；</li><li>如甲方未能按本合同规定时间向乙方支付广告服务费用，延迟时间超过一个月，乙方有权终止本合同；</li><li>在甲方完全履行本合同规定义务后，如乙方未能按本合同规定时间为甲方提供广告服务，延迟时间超过一个月，甲方有权终止本合同。</li></ol><h4>八、保密义务</h4><ol><li>双方为执行本协议提供给对方的任何技术产品或资料，除非提供方明确说明其为公知技术的外，均构成提供方的商业秘密；</li><li>双方同意不得使第三人接触或向第三人揭露上述商业秘密，也不得为本协议之外的任何其它目的利用该商业秘密。双方承诺，本保密义务延及其员工，任何一方员工违法本保密义务的，该方同样应承担全部法律责任。</li></ol><h4>九、免责条件</h4><ol><li>因战争、自然灾害等导致乙方服务器不能正常运行；</li><li>因政府行政行为导致乙方不能开放服务器；</li><li>因互联网灾难，中国、美国等互联网通讯提供商原因导致乙方服务器不能正常接入；</li><li>因乙方操作平台及应用软件原因导致乙方服务器临时性不能正常运行；</li><li>因乙方网站遭遇不法攻击导致服务器临时性不能正常运行。</li><li>基于以上原因，导致乙方网站不能正常运行，甲方认同属于正常现象，乙方不承担任何法律上和本合同规定以外的其它方式的责任。</li></ol><h4>十、争议解决</h4><ol><li>如双方在履行本合同过程中发生争议，经协商无法解决，任何一方均可向仲裁委员会提出仲裁，仲裁结果为最终结果，对双方都具有约束力。</li></ol><h4>十一、其他</h4><ol><li>甲方开始在乙方平台投放广告时该协议自动生效；</li><li>有效期至广告服务时间完成时为止。</li><li>本协议执行过程中，所有附件和补充协议等一经甲乙双方签字即成为本协议的有效组成部分 与本协议具有同等法律效力。</li></ol></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">关闭</button></div></div></div></div>");
$templateCache.put("app/advert-detail/advert-detail.html","<div class=\"container\"><div><h1 class=\"text-center\" ng-bind=\"advertisement.title\">广告标题</h1><h4 class=\"text-center\">广告类别:{{advertisement.catalog}}</h4><hr></div><div class=\"col-md-offset-2 col-sm-8 col-sm-offset-1 col-sm-10\"><table class=\"table table-hover table-striped table-bordered\"><tbody><tr><th>广告内容</th><td ng-bind=\"advertisement.content\"></td></tr><tr><th>广告地点</th><td ng-bind=\"locations\"></td></tr><tr><th>广告发布时段</th><td>24小时</td></tr><tr><th>广告播放开始日期</th><td ng-bind=\"advertisement.startDate\"></td></tr><tr><th>广告播放结束日期</th><td ng-bind=\"advertisement.endDate\"></td></tr><tr><th>广告单条费用</th><td>{{ advertisement.price }}&nbsp;MAD币</td></tr><tr><th>广告状态</th><td ng-bind=\"advertisement.state\"></td></tr></tbody></table></div></div><div class=\"text-center\"><button class=\"btn btn-primary text-right\" ui-sref=\"app.advert.edit({advertId: advertId})\" ng-disabled=\"advertisement.status === \'001\' || advertisement.status === \'100\'\">修改信息</button></div>");
$templateCache.put("app/advert-edit/advert-edit.html","<div class=\"container jx-container\"><div class=\"row\"><div class=\"col-sm-offset-2 col-sm-8\"><h2 class=\"text-center\" ng-bind=\"pageTitle\"></h2><p class=\"text-center\" ng-bind=\"pageDetail\"></p><hr><form class=\"form-horizontal panel-body\" role=\"form\" name=\"advertForm\" novalidate=\"novalidate\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">广告编号：</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"(不可修改)\" readonly=\"true\" ng-model=\"advertId\"></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">广告标题：</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"广告标题(不超过20字)\" name=\"title\" ng-model=\"advertisement.title\" required=\"\"> <span style=\"color:red\"><span ng-show=\"check.title.isEmpty\">广告名称是必须的。</span> <span ng-show=\"check.title.isTooLong\">广告标题不能超过20字</span></span></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">广告内容：</label><div class=\"col-sm-9\"><textarea class=\"form-control\" placeholder=\"广告内容(不超过60字)\" rows=\"3\" name=\"content\" ng-model=\"advertisement.content\" ng-change=\"changeContent(advertisement.content)\" required=\"\"></textarea> <span style=\"color:red\"><span ng-show=\"check.content.isEmpty\">广告内容是必须的。</span> <span ng-show=\"check.content.isTooLong\">广告内容不能超过60字</span></span></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">广告类别：</label><div class=\"col-sm-4\"><select class=\"form-control\" name=\"adType\" ng-model=\"advertisement.catalog\" ng-options=\"m.id as m.type for m in advertTypes\" ng-disabled=\"advertId !== null\"></select></div><div class=\"col-sm-4\" ng-hide=\"advertId === null\"><label style=\"font-size: 13px\">注意：广告类别不可修改</label></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">面向城市：</label><div class=\"col-sm-4\"><select class=\"form-control\" name=\"adCity\" ng-model=\"advertisement.city\" ng-options=\"c.id as c.city for c in advertCities\"></select></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">投放地点：</label><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-3 col-xs-4 checkbox\" ng-repeat=\"district in districts\"><label><input type=\"checkbox\" ng-change=\"changeDistrict()\" ng-model=\"district.selected\">{{district.name}}</label></div></div><span style=\"color:red\" ng-show=\"check.district.isEmpty\">广告投放地点是必须的。</span></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">开始播放日期：</label><div class=\"col-sm-9\"><input class=\"form-control\" type=\"date\" name=\"startDate\" ng-model=\"advertisement.startDate\" required=\"\"> <span style=\"color:red\"><span ng-show=\"check.startDate.isEmpty\">广告开始时间是必须的。</span></span></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">结束播放日期：</label><div class=\"col-sm-9\"><input class=\"form-control\" type=\"date\" name=\"endDate\" ng-model=\"advertisement.endDate\" required=\"\"> <span style=\"color:red\"><span ng-show=\"check.endDate.isEmpty\">广告结束时间是必须的。</span> <span ng-show=\"check.endDate.earlyThanStart\">广告结束时间不能早于开始时间</span></span></div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">单条广告价格：</label><div class=\"col-sm-9\"><strong><p class=\"form-control-static\">{{ advertisement.price }} MAD币</p></strong></div></div><div class=\"row button-group\"><div class=\"col-xs-4\"><button type=\"button\" class=\"btn btn-danger btn-fluit\" ui-sref=\"app.advert\">取消</button></div><div class=\"col-xs-4\"><button type=\"button\" class=\"btn btn-success btn-fluit\" ng-click=\"submitApply()\" ng-disabled=\"advertId === null\">提交审核</button></div><div class=\"col-xs-4\"><button type=\"button\" class=\"btn btn-default btn-fluit\" ng-click=\"saveDraft()\">暂存草稿</button></div></div></form></div></div></div><div class=\"modal fade bs-example-modal-sm\" id=\"successModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel2\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel2\">{{resultTitle}}</h4></div><div class=\"modal-body\">{{resultDetail}}</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">关闭</button></div></div></div></div>");
$templateCache.put("app/advertisment/advertisment.html","<div class=\"container jx-container\"><div class=\"row\"><div class=\"col-md-offset-1 col-md-10\"><h1 class=\"text-center\">已发布广告</h1><p class=\"text-center\">您的已发布广告列表</p><hr></div><div class=\"col-md-offset-1 col-md-10 panel panel-default\"><div class=\"panel-body\"><table st-table=\"advertCollection\" st-safe-src=\"advertList\" class=\"table table-striped\"><thead><tr><th>广告编号</th><th>广告标题</th><th>广告状态</th><th>创建时间</th><th>查看广告详情</th><th>修改广告</th></tr></thead><tbody><tr ng-repeat=\"row in advertCollection\"><td>{{row.number }}</td><td>{{row.title}}</td><td class=\"{{row.stateClass}}\">{{row.state}}</td><td>{{row.createTime}}</td><td><button ui-sref=\"app.advert.detail({advertId: row.id})\" class=\"btn btn-success btn-sm\">查看详情</button></td><td><button class=\"btn btn-danger btn-sm\" ng-show=\"row.isDisableOff\" ng-click=\"removeAdvertisementById(row.id)\">下架</button> <button class=\"btn btn-primary btn-sm\" ng-show=\"row.canSubmit\" ng-click=\"submitAdvertisementById(row.id)\">提交审核</button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/advertisment/pagination.custom.html","<div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div class=\"table-summary\">共<span class=\"red\">{{totalItemCount}}</span>条数据， 每页<span class=\"red\">{{stItemsByPage}}</span>条， 共<span class=\"red\">{{numPages}}</span>页</div></div><div class=\"col-xs-12 col-md-6\"><nav class=\"pull-right\" ng-if=\"numPages &amp;&amp; pages.length >= 2\"><ul class=\"pagination\"><li><a ng-click=\"selectPage(1)\">首页</a></li><li><a ng-click=\"selectPage(currentPage - 1)\">&lt;</a></li><li ng-repeat=\"page in pages\" ng-class=\"{active: page==currentPage}\"><a ng-click=\"selectPage(page)\">{{page}}</a></li><li><a ng-click=\"selectPage(currentPage + 1)\">&gt;</a></li><li><a ng-click=\"selectPage(numPages)\">尾页</a></li></ul></nav></div></div>");
$templateCache.put("app/blank/blank.html","");
$templateCache.put("app/main/main.html","<div id=\"carousel\" class=\"carousel slide body\" data-ride=\"carousel\"><ol class=\"carousel-indicators\"><li data-target=\"#carousel\" data-slide-to=\"0\" class=\"active\"></li><li data-target=\"#carousel\" data-slide-to=\"1\"></li><li data-target=\"#carousel\" data-slide-to=\"2\"></li></ol><div class=\"carousel-inner\" role=\"listbox\"><div class=\"item active\"><img src=\"assets/images/carousel-1.png\"><div class=\"container\"><div class=\"carousel-caption\"><h1>您是车主</h1><p>我们为您提供了一种新的方式来赚钱，<br>仅仅依靠您的汽车播放一些广告，您就可以轻松愉快地收获利润。</p><p><button type=\"button\" class=\"btn btn-success\" data-toggle=\"modal\" data-target=\"#downloadModal\">下载app</button></p></div></div></div><div class=\"item\"><img src=\"assets/images/carousel-2.png\"><div class=\"container\"><div class=\"carousel-caption\"><h1>您是广告商</h1><p>我们希望通过汽车这类频繁移动的工具为您播放广告，您可以自由选择时间与地点，借助汽车作为媒介来收获利润。</p><p><button class=\"btn btn-success\">点击右上角立即注册</button></p></div></div></div><div class=\"item\"><img src=\"assets/images/carousel-3.png\"><div class=\"container\"><div class=\"carousel-caption\"><h1>若您希望合作</h1><p>请发邮件至mad_info@163.com商讨合作事宜。</p></div></div></div></div><a class=\"left carousel-control\" href=\"#carousel\" role=\"button\" data-slide=\"prev\"><span class=\"glyphicon glyphicon-chevron-left\" aria-hidden=\"true\"></span> <span class=\"sr-only\">Previous</span></a> <a class=\"right carousel-control\" href=\"#carousel\" role=\"button\" data-slide=\"next\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span> <span class=\"sr-only\">Next</span></a></div><div class=\"container\"><h2 class=\"text-center\">用心投放每一单广告</h2><p class=\"text-center\">我们希望为您的每一单广告投放做担保，为更好地广告效益做努力</p><hr><div class=\"row\"><div class=\"col-md-4 col-md-offset-2 col-sm-6 text-center\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"xmd-img-center\"><img src=\"assets/images/ico_01.png\" class=\"img-responsive\" width=\"100\"></div><h4>实名认证</h4><p>100%认证车主驾照、广告商营业执照</p></div></div></div><div class=\"col-md-4 col-sm-6 text-center\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"xmd-img-center\"><img src=\"assets/images/ico_02.png\" class=\"img-responsive\" width=\"100\"></div><h4>收益保险</h4><p>车主与广告商信息安全，收益稳定</p></div></div></div></div><div class=\"row\"><div class=\"col-md-4 col-md-offset-2 col-sm-6 text-center\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"xmd-img-center\"><img src=\"assets/images/ico_03.png\" class=\"img-responsive\" width=\"100\"></div><h4>线上支付</h4><p>无缝对接支付宝等在线支付平台</p></div></div></div><div class=\"col-md-4 col-sm-6 text-center\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"xmd-img-center\"><img src=\"assets/images/ico_04.jpg\" class=\"img-responsive\" width=\"100\"></div><h4>提现便捷</h4><p>支持支付宝等提现方式</p></div></div></div></div><h2 class=\"text-center\">联系我们</h2><p class=\"text-center\">若您有任何疑问，欢迎通过邮件来联系我们</p><p class=\"text-center\">邮箱：mad_info@163.com</p></div><div class=\"modal fade\" id=\"downloadModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\"><div class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"myModalLabel\">下载App</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><img style=\"width:200px; margin:10px auto;\" src=\"http://mad-10035512.file.myqcloud.com/liuApp.jpg\" class=\"img-responsive\" alt=\"二维码图片\"><p class=\"text-center\">流应用二维码</p></div><hr><div class=\"col-md-12\"><div style=\"width:250px; margin:10px auto\"><p class=\"text-center\"><a href=\"http://o8e8i11ed.bkt.clouddn.com/H5661AF68_0607165646.apk\">Android App连接</a></p></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button></div></div></div></div>");
$templateCache.put("app/pact/pact.html","<div class=\"container\"><h1>车载广告服务协议</h1><h4>甲方:广告投放方</h4><h4>乙方:MAD移动广告投放平台</h4><p>双方本着友好协商、共同发展的原则，由乙方在网站，为甲方提供网络广告服务。</p><h4>一、服务内容</h4><ol><li>广告类型：本条所指广告内容是指甲方拟在乙方公司内所有广告载体上发布的有关甲方业务的信息，广告形式为静态文字。文字长最长不超过60字。</li><li>乙方将在乙方公司内符合投放条件的车载广告播放装置上发布甲方的广告内容</li></ol><h4>二、甲方的权利义务</h4><ol><li>甲方所要宣传的内容如有变动必须向乙方提交审核，以便乙方能及时调整更新广告信息。</li><li>甲方有权根据本合同第一条所要求的服务内容及标准，检查乙方提供的广告服务质量，如乙方提供的服务质量不符合本合同第一条的规定，甲方有权要求乙方在规定时间内做出补充和修正。</li><li>甲方发布的广告内容必须符合中国法律法规的规定，不得委托乙方发布国家明令禁止的广告内容。</li><li>甲方必须保证所发布广告的真实性、有效性，并独立承担责任。</li><li>甲方必须依据本合同规定，按时足额向乙方支付广告服务款项。</li></ol><h4>三、乙方的权利义务</h4><ol><li>乙方必须严格遵守中华人民共和国广告法及相关适用法律的相关规定及要求发布广告；</li><li>乙方必须按本合同规定第一条规定的服务内容及标准向甲方提供广告服务；</li><li>乙方有权要求甲方按其规定提供营业执照、资质证明等相关证明材料，甲方拒不提供的，乙方有权拒绝为其发布广告。</li><li>乙方一旦发现甲方提供的广告存在虚假成分，有权立即单方面撤除广告，并通知甲方澄清事实。由此造成的损失由甲方承担。</li><li>乙方有权要求甲方按时足额支付广告服务费用；</li></ol><h4>四、违约责任</h4><ol><li>双方中任何一方违反本合同的规定，均必须承担相应的法律责任，赔偿对方因此而造成的经济损失。</li><li>如乙方未能在本合同规定时间内，为甲方提供广告服务，每延迟一天，乙方须减收甲方广告服务费用总额的1%的作为补偿，如延迟时间超过一个月，甲方有权要求终止合同，乙方将向甲方退回全部预付款。</li><li>如甲方未能在本合同规定时间内，向乙方支付预付款及余款，每延迟一天，甲方须向乙方支付广告服务费用总额1%的赔偿金，如延迟时间超过一个月时间，乙方有权终止合同，并有权要求甲方赔偿广告服务费用总额双倍的经济赔偿金。</li><li>由于甲方提供广告中存在虚假成分，或因此引发第三方法律诉讼，要求经济赔偿等，甲方必须独立承担全部损失，并赔偿由此给乙方造成的一切名誉和经济损失。</li></ol><h4>五、服务费用</h4><ol><li>服务付费：单条广告价格根据乙方所投放广告自动计算得出，在广告投放时广告费用自动从乙方账户中扣除；</li><li>支付方式：乙方在投放广告前需向账户中充值足够金额以投放广告，所充值金额会自动兑换为等值MAD币。</li></ol><h4>六、知识产权</h4><ol><li>在本合同执行过程中而产生的广告作品著作权归制作方所有，即由甲方设计制作的广告作品著作权归甲方所有，由甲方委托乙方设计制作的广告作品著作权归乙方所有。</li></ol><h4>七、合同终止</h4><ol><li>如甲方不能提供广告相关商品或服务的资质证明、产品说明书或政府主管部门的审批文件，或提供的上述材料中存在虚假成分，或因此第三方的法律诉讼、经济索赔要求等情况，乙方有权终止本合同，且不承担任何责任；</li><li>如甲方未能按本合同规定时间向乙方支付广告服务费用，延迟时间超过一个月，乙方有权终止本合同；</li><li>在甲方完全履行本合同规定义务后，如乙方未能按本合同规定时间为甲方提供广告服务，延迟时间超过一个月，甲方有权终止本合同。</li></ol><h4>八、保密义务</h4><ol><li>双方为执行本协议提供给对方的任何技术产品或资料，除非提供方明确说明其为公知技术的外，均构成提供方的商业秘密；</li><li>双方同意不得使第三人接触或向第三人揭露上述商业秘密，也不得为本协议之外的任何其它目的利用该商业秘密。双方承诺，本保密义务延及其员工，任何一方员工违法本保密义务的，该方同样应承担全部法律责任。</li></ol><h4>九、免责条件</h4><ol><li>因战争、自然灾害等导致乙方服务器不能正常运行；</li><li>因政府行政行为导致乙方不能开放服务器；</li><li>因互联网灾难，中国、美国等互联网通讯提供商原因导致乙方服务器不能正常接入；</li><li>因乙方操作平台及应用软件原因导致乙方服务器临时性不能正常运行；</li><li>因乙方网站遭遇不法攻击导致服务器临时性不能正常运行。</li><li>基于以上原因，导致乙方网站不能正常运行，甲方认同属于正常现象，乙方不承担任何法律上和本合同规定以外的其它方式的责任。</li></ol><h4>十、争议解决</h4><ol><li>如双方在履行本合同过程中发生争议，经协商无法解决，任何一方均可向仲裁委员会提出仲裁，仲裁结果为最终结果，对双方都具有约束力。</li></ol><h4>十一、其他</h4><ol><li>甲方开始在乙方平台投放广告时该协议自动生效；</li><li>有效期至广告服务时间完成时为止。</li><li>本协议执行过程中，所有附件和补充协议等一经甲乙双方签字即成为本协议的有效组成部分 与本协议具有同等法律效力。</li></ol></div>");
$templateCache.put("app/notification/notification.html","<div class=\"container\"><div class=\"col-md-offset-1 col-md-10\"><h1>消息列表</h1><hr><div class=\"panel panel-default\" ng-repeat=\"ntf in notificationContents\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-1 col-xm-2 col-xs-3\"><img alt=\"...\" src=\"assets/images/avatar.jpg\" class=\"img-responsive img-circle\"></div><div class=\"col-md-11 col-sm-10 col-xs-9\"><div class=\"row\"><div class=\"col-xs-6\"><h4 class=\"media-heading text-left\">系统消息</h4></div><div class=\"col-xs-6\"><p class=\"text-right\">{{ntf.date}}</p></div></div><p>{{ntf.content}}</p></div></div></div></div></div></div>");
$templateCache.put("app/statistics/statistics.html","<div class=\"container\"><h1 class=\"text-center\">财务对账</h1><p class=\"text-center\">在这里核对您的支出信息</p><hr><div class=\"row row-margin\"><div class=\"col-xs-6 col-xs-3 col-xs-offset-3 col-md-2 col-md-offset-4\"><p class=\"lsr-p-position\">总支出: {{totalPay}} 元</p></div><div class=\"col-xs-6 col-md-3 col-md-2\"><p class=\"lsr-p-position\">总充值金额: {{totalTopUp}} 元</p></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><table st-table=\"advertCollection\" st-safe-src=\"advertList\" class=\"table table-hover\"><thead><tr><th>广告编号</th><th>广告标题</th><th>发布时间</th><th>次数统计</th><th>总花费(MAD币)</th><th>广告详情</th></tr></thead><tbody><tr ng-repeat=\"advert in advertCollection\"><td>{{ advert.id }}</td><td>{{ advert.title }}</td><td>{{ advert.startDate }}</td><td>{{ advert.broadcastSum }}</td><td>{{ advert.priceSum }}</td><td><button class=\"btn btn-sm btn-success\" ui-sref=\"app.statistics.detail({advertId: advert.id})\">查看详情</button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/statistics-advertis/statistics-advertis.html","<div class=\"container jx-container\"><div class=\"row\"><div class=\"col-md-offset-1 col-md-10\"><h1 class=\"text-center\">广告统计</h1><p class=\"text-center\">查看广告的支出统计和投放统计</p><hr></div><div class=\"col-md-offset-1 col-md-10\"><div id=\"chart1\"><h4 class=\"text-center\">广告商广告投放统计</h4><div id=\"chartdiv\" style=\"width: 100%; height: 500px;\"></div></div><div id=\"chart2\"><h4 class=\"text-center\">广告商广告支出统计</h4><div id=\"advertisment-chart\" style=\"width: 100%; height: 500px;\"></div></div></div></div></div>");
$templateCache.put("app/statistics-detail/statistics-detail.html","<div class=\"container\"><div class=\"row\"><div class=\"col-md-offset-1 col-md-10\"><h1 class=\"text-center\">广告统计</h1><p class=\"text-center\">查看本条广告的支出统计</p><hr></div><div class=\"col-md-offset-1 col-md-10\"><div><h4 class=\"text-center\">广告商2015、2016年单条广告支出统计</h4><div id=\"chartdiv\" style=\"width: 100%; height: 500px;\"></div></div></div></div></div>");
$templateCache.put("app/components/footer-advert/footer-advert.html","<hr><footer class=\"home-footer\"><div class=\"home-footer-text\"><p>地址：上海市嘉定区曹安公路4800号</p><p>&copy; 2016-2017 &middot; <a href=\"http://andyht.github.io/MAD_AdvertiserWeb/#/\">移动的广告MAD</a> &middot; All rights reserved.</p></div></footer>");
$templateCache.put("app/components/navbar-advert/navbar-advert.html","<nav class=\"navbar navbar-inverse\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\" aria-expanded=\"false\" aria-controls=\"navbar\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" ui-sref=\"app\"></a></div><div class=\"navbar-collapse collapse nav-margin-left\" id=\"navbar\"><ul class=\"nav navbar-nav\" ng-if=\"isLogin\"><li class=\"\" ng-class=\"{\'active\': isMain}\"><a ui-sref=\"app\" ui-sref-opts=\"{reload: true}\">首页</a></li><li class=\"dropdown\" ng-class=\"{\'active\': isManage}\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">广告管理<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li ng-class=\"{\'active\': isPush}\"><a ui-sref=\"app.advert.edit({advertId: null})\" ui-sref-opts=\"{reload: true}\">发布新广告</a></li><li ng-class=\"{\'active\': isList}\"><a ui-sref=\"app.advert\" ui-sref-opts=\"{reload: true}\">已发布广告</a></li></ul></li><li class=\"dropdown\" ng-class=\"{\'active\': isPay}\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">账户管理<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li ng-class=\"{\'active\': isPut}\"><a ui-sref=\"app.account.recharge\" ui-sref-opts=\"{reload: true}\">账户充值</a></li><li ng-class=\"{\'active\': isBack}\"><a ui-sref=\"app.account.refund\" ui-sref-opts=\"{reload: true}\">账户退款</a></li><li ng-class=\"{\'active\': isConfirm}\"><a ui-sref=\"app.account.check\" ui-sref-opts=\"{reload: true}\">账户验证</a></li></ul></li><li class=\"dropdown\" ng-class=\"{active: isStatistics}\"><a class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">统计<b class=\"caret\"></b></a><ul class=\"dropdown-menu\"><li ng-class=\"{active: isAccSta}\"><a ui-sref=\"app.statistics\" ui-sref-opts=\"{reload: true}\">账务对账</a></li><li></li><li ng-class=\"{active: isAdSta}\"><a ui-sref=\"app.statistics.advertis\" ui-sref-opts=\"{reload: true}\">广告统计</a></li></ul></li></ul><div class=\"navbar-header navbar-right nav-margin-right\"><ul class=\"nav navbar-nav\" ng-if=\"!isLogin\"><button type=\"button\" class=\"btn btn-signup navbar-btn\" data-toggle=\"modal\" data-target=\"#signup\">注册</button> <button type=\"button\" class=\"btn btn-signin navbar-btn\" data-toggle=\"modal\" data-target=\"#login\">登录</button></ul><ul class=\"nav navbar-nav\" ng-if=\"isLogin\"><li class=\"navbar-link\" ng-class=\"{active: isAccount}\"><a ui-sref=\"app.account\" ui-sref-opts=\"{reload: true}\" ng-bind=\"name\"></a></li><li ng-class=\"{active: isMsg}\"><a ui-sref=\"app.notification\" class=\"navbar-link\" ui-sref-opts=\"{reload: true}\">消息管理</a></li><li><a ng-click=\"logout()\"><span class=\"glyphicon glyphicon-log-out\" aria-hidden=\"true\"></span></a></li></ul></div></div></nav><div id=\"signup\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"signModalLabel\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content xmd-modal-content\"><div class=\"xmd-content\"><div class=\"row\"><div class=\"col-md-offset-1 col-md-4 col-sm-5 col-xs-offset-1 col-xs-10 xmd-left-content\"><img src=\"assets/images/favicon.ico\" class=\"img-responsive\"> <img src=\"assets/images/mad.png\" class=\"img-responsive\"></div><div class=\"col-md-offset-1 col-md-6 col-sm-6 col-xs-12 xmd-right-content\"><div class=\"ht-input-box\"><form role=\"form\" class=\"xmd-form\"><div class=\"form-group\"><div class=\"input-group ht-input\"><span class=\"input-group-addon\"><img src=\"assets/images/nickname.png\"></span> <input type=\"text\" class=\"form-control\" placeholder=\"昵称\" aria-describedby=\"basic-addon2\" ng-model=\"nickname\"></div></div><div class=\"form-group\"><div class=\"input-group ht-input\"><span class=\"input-group-addon\"><img src=\"assets/images/email.png\"></span> <input type=\"text\" class=\"form-control\" placeholder=\"邮箱\" aria-describedby=\"basic-addon2\" ng-model=\"email\"></div></div><div class=\"form-group\"><div class=\"input-group ht-input\"><span class=\"input-group-addon\"><img src=\"assets/images/password.png\"></span> <input type=\"password\" class=\"form-control\" placeholder=\"密码\" aria-describedby=\"basic-addon2\" ng-model=\"password\"></div></div><div class=\"form-group\"><div class=\"input-group ht-input\"><span class=\"input-group-addon\"><img src=\"assets/images/confirm.png\"></span> <input type=\"password\" class=\"form-control\" placeholder=\"确认密码\" aria-describedby=\"basic-addon2\" ng-model=\"passConfirm\"></div></div><span class=\"help-block\" ng-show=\"thereIsError\">{{ errMessage }}</span><div class=\"form-group\"><button class=\"btn btn-warning btn-lg xmd-btn-register\" ng-click=\"register(nickname, email, password, passConfirm)\">注册</button></div></form></div></div></div></div></div></div></div><div id=\"login\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"loginModalLabel\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content xmd-modal-content\"><div class=\"xmd-content\"><div class=\"row\"><div class=\"col-md-offset-1 col-md-4 col-sm-5 col-xs-offset-1 col-xs-10 xmd-left-content\"><img src=\"assets/images/favicon.ico\" class=\"img-responsive\"> <img src=\"assets/images/mad.png\" class=\"img-responsive\"></div><div class=\"col-md-offset-1 col-md-6 col-sm-6 col-xs-12 xmd-right-content\"><div class=\"ht-input-box\"><form role=\"form\" class=\"xmd-form\"><div class=\"form-group\"><div class=\"input-group ht-input\"><span class=\"input-group-addon\"><img src=\"assets/images/email.png\"></span> <input type=\"text\" class=\"form-control\" placeholder=\"邮箱\" aria-describedby=\"basic-addon2\" ng-model=\"email\"></div></div><div class=\"form-group\"><div class=\"input-group ht-input\"><span class=\"input-group-addon\"><img src=\"assets/images/confirm.png\"></span> <input type=\"password\" class=\"form-control\" placeholder=\"密码\" aria-describedby=\"basic-addon2\" ng-model=\"password\"></div><span class=\"help-block\" ng-show=\"thereIsError\">{{ errMessage }}</span></div><div class=\"form-group\"><button class=\"btn btn-warning btn-lg xmd-btn-register\" ng-click=\"login(email, password)\">登录</button></div></form></div></div></div></div></div></div></div>");}]);